
const translations = {
    "Notice!": "Uwaga!",
    "Are you sure that you want to delete this?": "Czy na pewno chcesz to usunąć?",
    "Confirm": "Potwierdź",
    "Cancel": "Anuluj",
    "Min": "Min.",
    "Max": "Maks.",
    "Before": "Przed",
    "After": "Po",
    "w": "t",
    "week": "tydzień",
    "weeks": "tygodni(e)",
    "d": "dz",
    "day": "dzień",
    "days": "dni",
    "Due date": "Termin wykonania",
    "Start date": "Data rozpoczęcia",
    "Internal date": "Data wewnętrzna",
    "Notes": "Uwagi",
    "Document": "Dokument",
    "Email": "E-mail",
    "Billing": "Rozliczenia",
    "Add": "Dodaj",
    "Archived": "Zarchiwizowano",
    "Cancelled": "Anulowano",
    "Active": "Aktywny",
    "Inactive": "Nieaktywny",
    "Client company": "Firma klienta",
    "General info": "Ogólne informacje",
    "Digitisation of client documents": "Digitalizacja dokumentów klienta",
    "Client portal": "Portal klienta",
    "Documents": "Dokumenty",
    "Members": "Członkowie",
    "Preferences": "Preferencje",
    "Yes": "Tak",
    "No": "Nie",
    "Total hours": "Suma godzin",
    "Extra hours": "Dodatkowe godziny",
    "Client": "Klient",
    "Tasks": "Zadania",
    "Disable Uku’s task templates": "Wyłącz szablony zadań Uku",
    "Set the estimation as time when the exact value is not entered": "Ustaw oszacowanie jako czas, w którym nie wprowadzono dokładnej wartości",
    "Checklist must be completed to finish the task": "Lista kontrolna musi zostać wypełniona, aby zakończyć zadanie",
    "Disable topic management for members": "Wyłącz zarządzanie tematami dla członków",
    "Disable time edit for members": "Wyłącz edycję czasu dla członków",
    "Allow time entries in future": "Zezwalaj na wprowadzanie czasu w przyszłości",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Klienci",
    "Disable adding new clients for members": "Wyłącz dodawanie nowych klientów dla członków",
    "Only administrators can edit documents": "Tylko administratorzy mogą edytować dokumenty",
    "Allow digitisation of client documents": "Pozwól na digitalizację dokumentów klienta",
    "Use my Microsoft account": "Użyj mojego konta Microsoft",
    "Disconnect my Microsoft account": "Odłącz moje konto Microsoft",
    "Connect my Microsoft account": "Połącz moje konto Microsoft",
    "Use my google account": "Użyj mojego konta Google",
    "Connect my google account": "Połącz moje konto Google",
    "Disconnect my google account": "Odłącz moje konto Google",
    "Emails": "E-maile",
    "Daily agenda": "Plan dnia",
    "Unread notifications": "Nieprzeczytane powiadomienia",
    "Task assigned to me": "Przydzielono mi zadanie",
    "Weekly summary": "Podsumowanie tygodnia",
    "Monthly summary": "Podsumowanie miesiąca",
    "Updates and tips": "Aktualizacje i wskazówki",
    "Overdue": "Zaległy",
    "1 day": "1 dzień",
    "1 day overdue": "1 dzień spóźnienia",
    "{0} days": "{0} dni",
    "{0} days overdue": "{0} dni spóźnienia",
    "{0} minute ago": "{0} minut temu",
    "{0} minutes ago": "{0} minut temu",
    "{0} hour ago": "{0} godzinę temu",
    "{0} hours ago": "{0} godzin temu",
    "Sunday": "Niedziela",
    "Monday": "Poniedziałek",
    "Tuesday": "Wtorek",
    "Wednesday": "Środa",
    "Thursday": "Czwartek",
    "Friday": "Piątek",
    "Saturday": "Sobota",
    "Sun": "Niedz",
    "Mon": "Pon",
    "Tue": "Wt",
    "Wed": "Śr",
    "Thu": "Czw",
    "Fri": "Pt",
    "Sat": "Sob",
    "January": "Styczeń",
    "February": "Luty",
    "March": "Marzec",
    "April": "Kwiecień",
    "May": "Maj",
    "June": "Czerwiec",
    "July": "Lipiec",
    "August": "Sierpień",
    "September": "Wrzesień",
    "October": "Październik",
    "November": "Listopad",
    "December": "Grudzień",
    "Jan": "Sty",
    "Feb": "Lut",
    "Mar": "Mar",
    "Apr": "Kwi",
    "Jun": "Cze",
    "Jul": "Lip",
    "Aug": "Sie",
    "Sep": "Wrz",
    "Oct": "Paź",
    "Nov": "Lis",
    "Dec": "Gru",
    "Today": "Dzisiaj",
    "Yesterday": "Wczoraj",
    "Day": "Dzień",
    "Days": "Dni",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} wd",
    "Weekly {0}": "Tygodniowo {0}",
    "Every {0}. week {1}": "Co {0}. tydzień {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Miesięcznie {0}. d",
    "Every {0}. month {1}. d": "Co {0}. miesiąc {1}. d",
    "{0}. d": "{0}. d",
    "Quarterly {0}. month {1}. d": "Kwartalnie {0}. miesiąc {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Co {0}. kwartał {1}. miesiąc {2}. d",
    "{0}. month {1}. d": "{0}. miesiąc {1}. d",
    "Yearly {0}": "Rocznie {0}",
    "Every {0}. year {1}": "Co {0}. rok {1}",
    "Mo": "Pon",
    "Tu": "Wt",
    "We": "Śr",
    "Th": "Czw",
    "Fr": "Pt",
    "Sa": "Sob",
    "Su": "Niedz",
    "and": "oraz",
    "{0}w": "{0}tyg",
    "{0}d": "{0}d",
    "before": "przed",
    "after": "po",
    "Project": "Projekt",
    "Quarter": "Kwartał",
    "Add your photo": "Dodaj swoje zdjęcie",
    "Adding file failed": "Nie udało się dodać pliku",
    "Please check the file.": "Sprawdź plik.",
    "You can only add pictures.": "Możesz tylko dodawać zdjęcia.",
    "Error": "Błąd",
    "Create new topic": "Utwórz nowy temat",
    "Name": "Nazwa",
    "Close": "Zamknij",
    "Find topic...": "Znajdź temat...",
    "New topic": "Nowy temat",
    "Invalid format": "Niepoprawny format",
    "Demo company account": "Demo konta firmowego",
    "Demo account will be deleted later. Do this for testing purposes only!": "Konto demo zostanie usunięte później. Zrób to tylko w celach testowych!",
    "Subscribe": "Subskrybuj",
    "Start demo": "Uruchom demo",
    "End demo": "Zakończ demo",
    "Free trial is expired - {0}": "Darmowa wersja wygasła — {0}",
    "Free trial {1} {2} left - {0}": "Darmowa wersja, zostało {1} {2} - {0}",
    "Add time": "Dodaj czas",
    "Billable": "Płatne",
    "Date": "Data",
    "Start": "Początek",
    "End": "Koniec",
    "Duration": "Czas trwania",
    "Split duration equally": "Równo podziel czas trwania",
    "Required field": "Wymagane pole",
    "Members list": "Lista członków",
    "Edit fields": "Edytuj pola",
    "Maximum number of selected columns has been exceeded": "Przekroczono maksymalną liczbę wybranych kolumn",
    "If you want to add a new column to the report, please remove an existing one first.": "Jeśli chcesz dodać nową kolumnę do raportu, najpierw usuń istniejącą.",
    "Snooze until...": "Odłóż na...",
    "Select date & time": "Wybierz datę i godzinę",
    "Tomorrow": "Jutro",
    "Later this week": "Później w tym tygodniu",
    "Next week": "W następnym tygodniu",
    "Add task": "Dodaj zadanie",
    "Checklist": "Lista kontrolna",
    "Start timer": "Włącz timer",
    "Add an item": "Dodaj przedmiot",
    "Add checklist item": "Dodaj element listy kontrolnej",
    "Convert to a task": "Konwertuj na zadanie",
    "Delete": "Usuń",
    "Delegate to...": "Przydziel do...",
    "Please select tasks from the same account": "Wybierz zadania z tego samego konta",
    "Follow": "Obserwuj",
    "Expand sidebar": "Rozwiń pasek boczny",
    "Nicely done!": "Dobra robota!",
    "You've finished all your tasks, take a second to recharge": "Ukończyłeś wszystkie swoje zadania, poświęć chwilę na odpoczynek",
    "Search tasks...": "Szukaj zadań…",
    "Search": "Szukaj",
    "select/unselect all": "zaznacz/odznacz wszystko",
    "Add new client": "Dodaj nowego klienta",
    "Account": "Konto",
    "Client name": "Nazwa klienta",
    "Select client": "Wybierz klienta",
    "New client": "Nowy klient",
    "Must be an integer": "Musi być liczbą całkowitą",
    "Must be a number": "Musi być liczbą",
    "Dashboard": "Pulpit nawigacyjny",
    "Calendar": "Kalendarz",
    "Report": "Raport",
    "Monitoring": "Monitorowanie",
    "Suppliers": "Dostawcy",
    "Events": "Wydarzenia",
    "Projects": "Projekty",
    "Help": "Pomoc",
    "Settings & Apps": "Ustawienia & aplikacje",
    "Profile": "Profil",
    "Collapse menu": "Collapse menu",
    "Expand menu": "Rozwiń menu",
    "Are you sure to delete this attachment?": "Czy na pewno chcesz usunąć ten załącznik?",
    "Select": "Wybierz",
    "Edit contacts": "Edytuj kontakty",
    "Add member": "Dodaj członka",
    "Add note": "Dodaj notatkę",
    "Open": "Open",
    "Reports": "Raporty",
    "Billing notes": "Noty rozliczeniowe",
    "Pinned notes": "Przypięte notatki",
    "Sub-companies": "Spółki zależne",
    "Contacts": "Kontakty",
    "Event info": "Informacje o zdarzeniu",
    "Project info": "Informacje o projekcie",
    "Summary": "Podsumowanie",
    "Task": "Zadanie",
    "Time": "Czas",
    "Collapse sidebar": "Zwiń pasek boczny",
    "Client Overview": "Przegląd klientów",
    "Event Overview": "Przegląd wydarzeń",
    "Project Overview": "Omówienie projektu",
    "Edit client": "Edytuj klienta",
    "Edit event": "Edytuj wydarzenie",
    "Edit project": "Edytuj projekt",
    "Show all": "Pokaż wszystko",
    "Collapse": "Zwiń",
    "by": "przez",
    "View all": "Pokaż wszystkie",
    "Add company event": "Dodaj wydarzenie firmowe",
    "Company": "Firma",
    "Info": "Informacje",
    "Holiday": "Dzień wolny",
    "All day(s)": "Wszystkie dni",
    "End date": "Data końcowa",
    "From": "Od",
    "Until": "Aż do",
    "Hours": "Godziny",
    "Link": "Odnośnik",
    "Save": "Zapisz",
    "Are you sure that you want to delete this company calendar event?": "Czy na pewno chcesz usunąć to wydarzenie z kalendarza firmowego?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Dodaj nową rolę",
    "New role": "Nowa rola",
    "Access enabled": "Dostęp włączony",
    "Waiting for files": "Oczekiwanie na pliki",
    "Uploaded": "Przesłano",
    "Uploading...": "Przesyłanie...",
    "Client members": "Członkowie grupy klientów",
    "Email settings": "Ustawienia e-maila",
    "Or connect new email address": "Lub połącz z nowym adresem e-mail",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Połącz z Microsoft Exchange lub innym serwerem poczty elektronicznej (SMTP)",
    "Test email sent": "Wysłano e-maila testowego",
    "Email address": "Adres e-mail",
    "Reply address": "Adres do odpowiedzi",
    "Sender name": "Nazwa nadawcy",
    "Who can use?": "Kto może korzystać?",
    "Client default address": "Domyślny adres klienta",
    "Invalid e-mail": "Niepoprawny e-mail",
    "Role": "Rola",
    "E-mail": "E-mail",
    "Mobile phone": "Telefon komórkowy",
    "Work phone": "Telefon służbowy",
    "Language": "Język",
    "Birthday": "Data urodzenia",
    "Are you sure to delete this contact?": "Czy na pewno chcesz usunąć ten kontakt?",
    "Manage contact fields": "Zarządzaj polami kontaktów",
    "Administrative Assistant": "Asystent Administracyjny",
    "Board member": "Członek zarządu",
    "CEO": "Dyrektor generalny",
    "Add contact": "Dodaj kontakt",
    "Contact person": "Osoba kontaktowa",
    "Leave page?": "Opuść stronę?",
    "Changes that you made may not be saved": "Zmiany, które wprowadziłeś, mogą nie zostać zapisane",
    "Leave": "Wyjdź",
    "Super! We're importing your clients...": "Super! Importujemy Twoich klientów...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Możesz opuścić tę stronę. Po przygotowaniu importu pojawi się powiadomienie. Następnie musisz potwierdzić klientów, których chcesz dodać do Uku.",
    "Please wait...": "Proszę czekać...",
    "Setup API keys": "Skonfiguruj klucze API",
    "You have two options": "Masz dwie opcje",
    "how to setup API keys": "jak skonfigurować klucze API",
    "Continue": "Kontynuuj",
    "Custom import": "Niestandardowy import",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Aby zaimportować klientów i ilość pracy z !INTEGRATION, Uku potrzebuje klucza !INTEGRATION API dla każdego klienta.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Kontynuuj</span> – Uku automatycznie tworzy klucze API dla każdego klienta",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Import niestandardowy</span> – Uku łączy się tylko z istniejącymi kluczami API UKU. Utwórz klucze API ręcznie w !INTEGRATION przed importem. Przeczytaj:",
    "(it takes a lot of time)": "(zajmuje dużo czasu)",
    "Import Clients": "Add & update data",
    "Country": "Kraj",
    "Please choose your country": "Proszę wybrać swój kraj",
    "Password": "Hasło",
    "Start import": "Rozpocznij import",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Wstaw dane logowania !INTEGRATION (bezpieczne), aby dać jednorazowy dostęp do importu klientów i kluczy API. Pamiętaj, że zostaniesz wylogowany z !INTEGRATION w innych przeglądarkach.",
    "Update invoice status": "Zaktualizuj status faktury",
    "Update now": "Aktualizuj teraz",
    "Daily @ 14:00": "Codziennie o 14:00",
    "Daily @ 18:00": "Codziennie o 18:00",
    "Updating invoice statuses, please wait...": "Aktualizuję statusy faktur, proszę czekać...",
    "Your import is ready": "Twój import jest gotowy",
    "In the final step you need to confirm the clients you want to add to uku": "W ostatnim kroku musisz potwierdzić klientów, których chcesz dodać do Uku",
    "Let's go": "Chodźmy",
    "Import again": "Importuj ponownie",
    "Do you have new clients to import?": "Masz nowych klientów do importu?",
    "Yes, i do": "Tak",
    "View last import": "Zobacz ostatni import",
    "Email server": "Serwer e-mail",
    "Email provider": "Dostawca poczty e-mail",
    "Host": "Host",
    "Port": "Port",
    "Security": "Bezpieczeństwo",
    "Sender email": "E-mail nadawcy",
    "Username": "Nazwa użytkownika",
    "Test connection": "Połączenie testowe",
    "How to set up": "Jak skonfigurować",
    "Only administrators can activate the app": "Aplikacja może być aktywowana tylko przez administratorów",
    "You are in the waiting list": "Znajdujesz się na liście oczekujących",
    "We onboard all applicants one by one": "Zaznacz swoje zainteresowanie, a powiadomimy cię, gdy aplikacja będzie dostępna do testów",
    "Connected": "Połączony",
    "Activated": "Aktywowany",
    "Join waiting list": "Dołącz do listy oczekujących",
    "Activate": "Aktywuj",
    "Unsubscribe from waiting list": "Wypisz się z listy oczekujących",
    "Deactivate app": "Dezaktywuj aplikację",
    "Disconnect": "Rozłącz",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "E-mail nie został dostarczony",
    "Sent, but fallback to Uku email": "Wysłano, ale powrócono do wiadomości e-mail Uku",
    "Unknown error": "Nieznany błąd",
    "to": "do",
    "in any minute": "w każdej chwili",
    "on {0},": "w {0},",
    "or": "lub",
    "Send now": "Wyślij teraz",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>wysyła</span> emaila",
    "__From_email": "Email od",
    "Set up email": "Konfiguracja e-maila",
    "Client default": "Domyślny klient",
    "Subject": "Temat",
    "Edit email": "Edytuj e-maila",
    "Template": "Szablon",
    "Cc": "Cc",
    "Bcc": "Bcc",
    "__To_email": "Email do",
    "__Cc_email": "Cc",
    "__Bcc_email": "Bcc",
    "Add template": "Dodaj szablon",
    "Add automation": "Dodaj automatyzację",
    "Add placeholder": "Dodaj znacznik",
    "Format text": "Formatuj tekst",
    "Add attachment": "Dodaj załącznik",
    "Send": "Wyślij",
    "Save automation": "Zapisz automatyzację",
    "Choose email template": "Wybierz szablon e-maila",
    "All languages": "Wszystkie języki",
    "No templates found.": "Brak odnalezionych szablonów.",
    "Edit email template": "Edytuj szablon e-maila",
    "Are you sure you want to delete this template? Some tasks will be affected": "Czy na pewno chcesz usunąć ten szablon? Niektóre zadania zostaną zmienione",
    "Are you sure you want to delete this template?": "Czy na pewno chcesz usunąć szablon?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Czy na pewno chcesz zapisać ten szablon, poniższe zadania zostaną zmienione?",
    "Template name": "Nazwa szablonu",
    "Edit template": "Edytuj szablon",
    "Send email": "Wyślij e-mail",
    "on": "w",
    "Ok": "Ok",
    "Supplier": "Dostawca",
    "Event": "Wydarzenie",
    "Contact": "Kontakt",
    "Validation failed": "Weryfikacja nie powiodła się",
    "Saving supplier failed": "Zapisywanie dostawcy nie powiodło się",
    "Saving client failed": "Zapisywanie klienta nie powiodło się",
    "Saving project failed": "Zapisanie projektu nie powiodło się",
    "several values": "kilka wartości",
    "values": "wartości",
    "is": "jest",
    "Add filter": "Dodaj filtr",
    "Update": "Aktualizacja",
    "forever": "na zawsze",
    "Last week": "Zeszły tydzień",
    "This week": "Ten tydzień",
    "Last month": "Zeszły miesiąc",
    "This month": "Ten miesiąc",
    "Next month": "Przyszły miesiąc",
    "Last year": "Zeszły rok",
    "This year": "Ten rok",
    "This quarter": "Ten kwartał",
    "Next quarter": "Następny kwartał",
    "Last quarter": "Ostatni kwartał",
    "Client group": "Grupa klientów",
    "Topic": "Temat",
    "Member": "Członek",
    "Primary member": "Członek podstawowy",
    "Client status": "Status klienta",
    "Active clients": "Aktywni klienci",
    "Inactive clients": "Nieaktywni klienci",
    "All": "Wszyscy",
    "Project status": "Status projektu",
    "Member status": "Status członka",
    "Active members": "Aktywni członkowie",
    "Limited members": "Ograniczona liczba członków",
    "Inactive members": "Nieaktywni członkowie",
    "Contract status": "Status umowy",
    "Active contracts": "Aktywne umowy",
    "Pending contracts": "Oczekujące umowy",
    "Finished contracts": "Zakończone umowy",
    "Contract template": "Wzór umowy",
    "Payment recurrence": "Powtarzanie płatności",
    "Yearly": "Roczny",
    "Monthly": "Miesięczny",
    "Trial": "Okres próbny",
    "Region": "Region",
    "Field": "Pole",
    "All tasks": "Wszystkie zadania",
    "Todo": "Do zrobienia",
    "Not done": "Nie skończone",
    "Done": "Gotowe",
    "Delayed": "Opóźniony",
    "Important": "Ważny",
    "Extra work": "Dodatkowa praca",
    "I Follow": "Obserwuję",
    "Commented": "Skomentowane",
    "Tracked time": "Śledzony czas",
    "Estimated": "Szacowany",
    "Recurring task": "Zadanie cykliczne",
    "Last import": "Ostatni import",
    "Period": "Okres",
    "Client search": "Wyszukiwanie klienta",
    "Voucher": "Bon",
    "Company status": "Status firmy",
    "Deleted": "Usunięte",
    "All status": "Wszystkie statusy",
    "Payment gateway": "Bramka płatności",
    "All gateways": "Wszystkie bramki",
    "Uku manually": "Uku ręcznie",
    "Braintree": "Braintree",
    "Plan status": "Status planu",
    "All plans": "Wszystkie plany",
    "Paid": "Zapłacony",
    "Paid churn": "Płatna rezygnacja",
    "Trial churn": "Trial churn",
    "Plan period": "Okres objęty planem",
    "All periods": "Wszystkie okresy",
    "Monthly plan": "Plan miesięczny",
    "Yearly plan": "Plan roczny",
    "Company search": "Wyszukiwanie firm",
    "User search": "Wyszukiwanie użytkowników",
    "Name key search": "Wyszukiwanie według klucza nazwy",
    "None filter": "Brak filtra",
    "OK": "OK",
    "Start date cannot be later than due date": "Data rozpoczęcia nie może być późniejsza niż termin płatności",
    "tasks": "zadania",
    "task(s) had errors": "zadania zawierały błędy",
    "tasks selected": "wybrane zadania",
    "Postpone": "Odłóż",
    "Mark done": "Oznacz jako gotowe",
    "Hide multiselect": "Ukryj wybór wielokrotny",
    "Delete task(s)": "Usuń zadanie(a)",
    "All of the data related to the task will be deleted": "Wszystkie dane związane z zadaniem zostaną usunięte",
    "Some tasks include other people. Are you sure you want to delete?": "Niektóre zadania obejmują inne osoby. Czy na pewno chcesz je usunąć?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Czas został przypisany do wybranych aktywności. Czy na pewno chcesz je usunąć?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Czas został przypisany do wybranych działań. Niektóre zadania obejmują inne osoby. Czy na pewno chcesz je usunąć?",
    "task(s) were not marked done": "zadanie(a) nie zostało(y) oznaczone jako wykonane",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Prosimy o sprawdzenie, czy lista kontrolna została wypełniona lub czy wpisano czas i czy są one przypisane do Państwa",
    "task(s) were not deleted": "zadanie(a) nie zostało(y) usunięte",
    "task(s) time was not updated": "czas zadania (zadań) nie został zaktualizowany",
    "Please make sure that you can add time to task": "Upewnij się, że możesz dodać czas do zadania",
    "invoice table row": "wiersz tabeli faktur",
    "invoice table row(s) had errors": "wiersze tabeli faktur zawierały błędy",
    "invoice table row(s) selected": "wybrane wiersze tabeli faktur",
    "Create": "Utwórz",
    "Mark paid": "Oznacz jako opłacone",
    "Send to client": "Wyślij do klienta",
    "Recalculate": "Przelicz",
    "Export to {0}": "Eksportuj do {0}",
    "Update Status from {0}": "Zaktualizuj status z {0}",
    "Void invoice": "Nieważna faktura",
    "Delete invoice": "Usuń fakturę",
    "Restore invoice": "Przywróć fakturę",
    "Mark unpaid": "Oznacz jako nieopłacone",
    "Invoices": "Faktury",
    "Download to Excel": "Pobierz do Excela",
    "Revenue split": "Podział przychodów",
    "Tax": "Podatek",
    "Description": "Opis",
    "Percent": "Procent",
    "Integration Id": "Identyfikator integracji",
    "Integration Code": "Kod integracji",
    "Name on invoice": "Nazwa na fakturze",
    "Restore": "Przywróć",
    "Archive": "Zarchiwizuj",
    "Hide": "Ukryj",
    "Are you sure?": "Czy jesteś pewien?",
    "Import finished!": "Zakończono import!",
    "Failed to import {0} records": "Nie udało się zaimportować {0} rekordów",
    "Download report": "Pobierz raport",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Wynik: dodano {0}, zaktualizowano {1}, pominięto {2}, nie udało się zaimportować {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Wynik: dodano {0}, zaktualizowano {1}, pominięto {2}",
    "What’s next?": "Co dalej?",
    "To work effectively with your client base, complete the following steps:": "Aby skutecznie współpracować z bazą klientów, wykonaj następujące czynności:",
    "Read more ›": "Czytaj więcej >",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Następnie zobaczysz tylko aktywnych zaimportowanych klientów. Aby zobaczyć wszystkich klientów, usuń filtr \"Ostatni import\".",
    "View clients": "Zobacz klientów",
    "Add <b>primary member</b> to every client.": "Dodaj <b>podstawowego członka</b> do każdego klienta.",
    "Add <b>task plan</b> to automate recurring tasks.": "Dodaj <b>plan zadań</b>, aby zautomatyzować powtarzające się zadania.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Ustaw automatyczne podsumowanie miesięczne w aplikacji {0} w Uku, aby importować ilość pracy.",
    "Title": "Tytuł",
    "Field type": "Typ pola",
    "Field name": "Nazwa pola",
    "Group name": "Nazwa grupy",
    "Choices": "Wybory",
    "Type each choice on a separate line": "Wpisz każdy wybór w osobnym wierszu",
    "Required": "Wymagany",
    "For all topics": "Dla wszystkich tematów",
    "For specific topics": "Dla konkretnych tematów",
    "Topics": "Tematy",
    "Non-billable": "Niepłatne",
    "Edit task custom field": "Edytuj niestandardowe pole zadania",
    "Add task custom field": "Dodaj niestandardowe pole zadania",
    "Edit client custom field": "Edytuj niestandardowe pole klienta",
    "Add client custom field": "Dodaj niestandardowe pole klienta",
    "Choice {0}": "Wybór {0}",
    "Are you sure that you want to delete this custom field?": "Czy na pewno chcesz usunąć to pole niestandardowe?",
    "Warning!": "Ostrzeżenie!",
    "This custom field is in use. Do you wish to archive it?": "To pole niestandardowe jest w użyciu. Czy chcesz je zarchiwizować?",
    "Reconnect": "Na nowo połączyć",
    "Send test email": "Wyślij testowy e-mail",
    "Email address or username": "Adres e-mail lub nazwa użytkownika",
    "Other": "Inne",
    "Set default email server for company": "Ustaw domyślny serwer poczty elektronicznej dla firmy",
    "My default email": "Mój domyślny e-mail",
    "Depends on": "Zależy od",
    "Todo - Blocking": "Do zrobienia - Blokowanie",
    "In progress - Blocking": "W toku - Blokowanie",
    "In progress": "W toku",
    "Client code": "Kod klienta",
    "Primary user": "Główny użytkownik",
    "Added date": "Data dodania",
    "Updated": "Zaktualizowano",
    "Contract count": "Liczba umów",
    "Integration": "Integracja",
    "No data available": "Brak dostępnych danych",
    "No results found": "Nie znaleziono żadnych wyników",
    "Loading": "Ładowanie",
    "Sort by": "Sortuj wg",
    "Rows per page": "Wierszy na stronie",
    "{0}-{1} of {2}": "{0}-{1} z {2}",
    "Ongoing": "Trwający",
    "important": "ważne",
    "Read more": "Czytaj więcej",
    "Add to previous time entry": "Dodaj do poprzedniego zapisu czasu",
    "Add to next time entry": "Dodaj do następnego zapisu czasu",
    "Add new task": "Dodaj nowe zadanie",
    "Cut previous time entry": "Przerwij poprzedni zapis czasowy",
    "Cut next time entry": "Przerwij następny zapis czasowy",
    "Missing time entry": "Brakujący zapis czasu",
    "Overlapping time entries": "Nakładające się wpisy czasowe",
    "Member from custom fields": "Członek z pól niestandardowych",
    "Delegated to": "Wydelegowano do",
    "Delegated by": "Wydelegowano przez",
    "Visible members": "Widoczni członkowie",
    "Member type": "Rodzaj członkostwa",
    "Groups": "Grupy",
    "Custom field": "Niestandardowe pole",
    "Contact search": "Wyszukaj kontakt",
    "Task start": "Rozpoczęcie zadania",
    "Task due": "Zadanie do wykonania",
    "Task finish": "Zakończenie zadania",
    "Custom date": "Własna data",
    "Never": "Nigdy",
    "Agreed work is still expected": "Nadal oczekuje się uzgodnionej pracy",
    "Accepted flextime": "Flextime accepted",
    "Declined flextime": "Flextime declined",
    "Cancelled flextime": "Flextime cancelled",
    "Updated flextime": "Flextime updated",
    "Calendar deleted": "Vacation deleted",
    "Calendar created": "Vacation requested",
    "Calendar approved": "Vacation approved",
    "Calendar declined": "Vacation declined",
    "Calendar updated": "Vacation updated",
    "Flextime balance updated": "Zaktualizowano bilans czasu pracy",
    "Flextime": "Flextime",
    "Vacation": "Wakacje",
    "Balance": "Saldo",
    "Comment": "Komentarz",
    "History": "Historia",
    "Action": "Czynność",
    "Who": "Kto",
    "Take a vacation or mark an absence": "Weź urlop lub zaznacz nieobecność",
    "Away": "Z dala",
    "Flextime bonus": "Premia za elastyczny czas pracy",
    "Approver": "Zatwierdzający",
    "Vacation available": "Dostępne wakacje",
    "Type": "Rodzaj",
    "Reduce agreed working hours": "Skrócenie uzgodnionych godzin pracy",
    "Reject": "Odrzucić",
    "Approve": "Zatwierdzić",
    "away_type_Away": "Away",
    "Sick leave": "Zwolnienie lekarskie",
    "Parental leave": "Urlop rodzicielski",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Razem",
    "Settings": "Ustawienia",
    "Work on holidays": "Pracować w święta",
    "Expand": "Rozwiń",
    "Wait until event status": "Poczekaj na status zdarzenia",
    "Wait until project status": "Poczekaj na status projektu",
    "Week(s)": "Tydzień/Tyg.",
    "Day(s)": "Dzień/Dni",
    "Rule": "Regulamin",
    "Depends on event": "Zależy od wydarzenia",
    "Depends on project": "Zależy od projektu",
    "Due date in": "Termin do",
    "Status": "Status",
    "Select event": "Wybierz wydarzenie",
    "Select project": "Wybierz projekt",
    "Find event...": "Znajdź wydarzenie...",
    "Find project...": "Znajdź projekt...",
    "Custom recurrence": "Niestandardowy cykl",
    "Every": "Każdy",
    "In case of holiday": "W przypadku wakacji",
    "Set time": "Ustaw czas",
    "Start time": "Czas rozpoczęcia",
    "Repeat from": "Powtórz od",
    "Previous repeat from: {0}": "Poprzednie powtórzenie od: {0}",
    "On date": "W dniu",
    "Plus days": "Plus dni",
    "Due date time": "Termin płatności",
    "Remove recurrence": "Usuń nawrót",
    "Repeat": "Powtarzaj",
    "month": "miesiąc",
    "quarter": "kwartał",
    "year": "rok",
    "1st month": "1 miesiąc",
    "2nd month": "2 miesiąc",
    "3rd month": "3 miesiąc",
    "Day {0}": "Dzień {0}",
    "Show before": "Pokaż przed",
    "Keep the day": "Zapisz dzień",
    "Show after": "Pokaż po",
    "From start date": "Od daty rozpoczęcia",
    "From beginning of the month": "Od początku miesiąca",
    "All days (Mon to Sun)": "Wszystkie dni (od poniedziałku do niedzieli)",
    "Mon to Fri (incl. holidays)": "Od poniedziałku do piątku (w tym święta)",
    "Mon to Fri (excl. holidays)": "Od poniedziałku do piątku (bez świąt)",
    "1st": "1.",
    "2nd": "2.",
    "3rd": "3.",
    "Does not repeat": "Nie powtarza się",
    "Daily": "Codziennie",
    "Weekly on {0}": "Co tydzień w {0}",
    "Monthly on day {0}": "Miesięcznie w dniu {0}",
    "Quarterly on {0} month {1} day": "Kwartalnie w {0} miesiącu {1} dniu",
    "Yearly on {0} {1}": "Rocznie w dniu {0} {1}",
    "Custom...": "Niestandardowe...",
    "Incorrect time": "Nieprawidłowy czas",
    "Add repeat": "Dodaj powtarzanie",
    "Email added to queue": "E-mail dodany do kolejki",
    "Communication timeline": "Harmonogram komunikacji",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktywuj aplikację Email App w App Store, aby wysyłać automatyczne wiadomości e-mail i przeglądać swoją przeszłą i przyszłą komunikację w jednym miejscu.",
    "Go to App Store": "Skonfiguruj aplikację",
    "Unknown": "Nieznany",
    "<b>Email</b> from": "<b>E-mail</b> od",
    "To": "Do",
    "Planned": "Zaplanowano",
    "Automated emails scheduled to be sent in the future": "Zautomatyzowane wiadomości e-mail zaplanowane do wysłania w przyszłości",
    "Send e-mail": "Wyślij e-maila",
    "Template unlinked": "Rozłączono szablon",
    "Icon": "Ikona",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Widoczny",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Domyślna firma",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Znajdź członka...",
    "I'll take it": "Wezmę to",
    "Remove me": "Usuń mnie",
    "Remove from task": "Usuń z zadania",
    "Learn more": "Dowiedz się więcej",
    "Company settings edit is disabled by owner": "Edycja ustawień firmy jest wyłączona przez właściciela",
    "<b>Exported</b> {0} to {1}": "<b>Wyeksportowano</b> {0} do {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Płatne {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Unieważniony</b> {0}",
    "Do you wish to mark the task done for everyone?": "Czy chcesz oznaczyć zadanie jako wykonane dla wszystkich?",
    "No, remove me": "Nie, usuń mnie",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Zadanie nie zostanie oznaczone jako wykonane, ale użytkownik zostanie usunięty z listy osób odpowiedzialnych i dodany do listy osób śledzących zadanie",
    "Invalid email": "Niepoprawny e-mail",
    "Accounting": "Księgowość",
    "General": "Ogólny",
    "Advertising / Marketing/ PR": "Reklama / Marketing / PR",
    "Architecture": "Architektura",
    "Construction": "Budowa",
    "Consulting - IT, software": "Doradztwo - IT, oprogramowanie",
    "Consulting - Management": "Doradztwo - Zarządzanie",
    "Finance": "Finanse",
    "Legal": "Prawo",
    "Medicine / Pharmacy ": "Medycyna / Farmacja ",
    "Non-profit": "Non-profit",
    "Web design": "Projektowanie stron",
    "Web development": "Tworzenie stron internetowych",
    "Max 140 characters": "Maksymalnie 140 znaków",
    "Please complete the checklist": "Proszę wypełnić listę kontrolną",
    "It is required to mark all checklist items as done": "Wymagane jest zaznaczenie wszystkich pozycji listy kontrolnej jako wykonane",
    "Please enter time spent": "Podaj czas spędzony",
    "Inserting time is essential for this client": "Wprowadzenie czasu jest kluczowe dla tego klienta",
    "Only me": "Tylko ja",
    "Private": "Prywatne",
    "Edit note": "Edytuj notatkę",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Dodaj dodatkowe informacje o kliencie, takie jak specjalne umowy, hasła itp.",
    "Edit": "Edytuj",
    "Workdays": "Dni robocze",
    "Workhours": "Godziny pracy",
    "Weeks": "Tygodnie",
    "Clear filters": "Wyczyść filtry",
    "Save filters": "Zapisz filtry",
    "Expected": "Oczekiwany",
    "Estimation": "Oszacowanie",
    "Do you also want to postpone the due date?": "Czy chcesz również przesunąć termin?",
    "{0} week": "{0} tydzień",
    "{0} weeks": "{0} tygodni",
    "Vacations": "Wakacje",
    "Holidays": "Wakacje",
    "Tax dates": "Daty podatkowe",
    "Accounting news": "Nowości księgowe",
    "Company events": "Wydarzenia firmowe",
    "Member birthdays": "Urodziny członków",
    "Contact birthdays": "Kontakt w sprawie urodzin",
    "Group items": "Pozycje grupowe",
    "Don't group": "Nie grupuj",
    "{0} away": "{0} daleko",
    "Member birthday | Member birthdays": "Urodziny członka | Urodziny członka",
    "Contact birthday | Contact birthdays": "Kontakt urodziny | Kontakt urodziny",
    "Contact birthday": "Urodziny kontaktu",
    "Member birthday": "Urodziny członka",
    "Are you sure you wish to delete this link?": "Czy na pewno chcesz usunąć ten link?",
    "Reference name": "Nazwa referencyjna",
    "Reference link": "Link referencyjny",
    "Free trial": "Spróbuj za darmo",
    "Solo": "Solo",
    "Team": "Team",
    "Enterprise": "Enterprise",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Wtyczka przeglądarki Chrome dla Uku do zarządzania zadaniami, klientami i śledzeniem czasu.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Skonfiguruj plany zadań/zleceń, aby zautomatyzować przepływ pracy, dodawać tematy, niestandardowe pola i modyfikować preferencje.",
    "Setup client groups, custom fields and modify your preferences.": "Skonfiguruj grupy klientów, niestandardowe pola i zmodyfikuj preferencje.",
    "test": "test",
    "Anti Money Laundering": "Przeciwdziałanie praniu brudnych pieniędzy",
    "Setup your customer AML and get instant reminders when auditing is due.": "Skonfiguruj AML klienta i otrzymuj natychmiastowe przypomnienia, gdy nadejdzie termin audytu.",
    "flextime_description": "flextime_description",
    "Smart Accounts": "Smart Accounts",
    "Automatically imports work statistics from your accounting software.": "Automatycznie importuje statystyki pracy z oprogramowania księgowego.",
    "Merit Aktiva": "360 Księgowość",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Przyspiesz proces rozliczania klientów dzięki cennikom i inteligentnym kontraktom.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Raport wizualny powie dokładnie, jak dochodowy lub nieopłacalny jest Twój klient.",
    "Emailing description": "Wysyłaj e-maile bezpośrednio z Uku i zautomatyzuj cykliczne e-maile.",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Import clients and automate your billing. Send all invoices to e-conomic with just four clicks.",
    "Xero": "Xero",
    "xero_description": "Import clients from Xero to Uku and automate your billing.",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "Import clients from QuickBooks Online to Uku and automate your billing.",
    "Tripletex": "Tripletex",
    "tripletex_description": "Import clients from Tripletex to Uku and automate your billing.",
    "Scoro": "Scoro",
    "Export sales invoices.": "Eksportuj faktury sprzedaży.",
    "Fortnox": "Fortnox",
    "fortnox_description": "Import clients from Fortnox to Uku and automate your billing.",
    "Magic button": "Magiczne przyciski",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Wystarczy jedno kliknięcie - szybki i łatwy sposób na tworzenie ważnych zadań. Na przykład, telefon od klienta.",
    "With suppliers, you make your projects and partners management more efficient.": "Dzięki dostawcom usprawniasz zarządzanie projektami i partnerami.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Wydajne i elastyczne zarządzanie projektami służy różnym przypadkom użycia i cyklom pracy.",
    "client_portal_app_description": "Client portal simplifies collaboration with clients. Securely receive documents, give tasks, and share information.",
    "Chat": "Czat",
    "chat_app_description": "Enhance team collaboration, client communication, and overall efficiency with the Chat.",
    "Companies House": "Companies House",
    "companies_house_app_description": "Brytyjski rejestr biznesowy",
    "documents_app_description": "documents_app_description",
    "Connect and discover tools to help you manage your business.": "Połącz się i odkryj narzędzia, które pomogą Ci zarządzać firmą.",
    "Subscribe now": "Subskrybuj teraz",
    "Compare plans": "Porównaj plany",
    "Add company": "Dodaj firmę",
    "BETA": "BETA",
    "Setup": "Konfiguracja",
    "Power up": "Wzmocnienie",
    "Integrations": "Integracje",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Chcesz pracować w zespole i korzystać z dodatkowych funkcji? Nie ma problemu, najpierw dodaj swoją firmę!",
    "Read more about Uku plans": "Przeczytaj więcej o planach Uku",
    "Contact role": "Rola kontaktowa",
    "Contact roles": "Role kontaktowe",
    "Client groups": "Grupy klientów",
    "Client fields": "Pola klienta",
    "Contact fields": "Pola kontaktowe",
    "View archive": "Przeglądaj archiwum",
    "Restore from archive": "Przywróć z archiwum",
    "Empty list": "Wyczyść listę",
    "Task fields": "Pola zadań",
    "task topics": "tematy zadań",
    "Keep the task opened when starting the timer": "Pozostaw zadanie otwarte podczas uruchamiania stopera",
    "task templates": "szablony zadań",
    "Author": "Autor",
    "Duplicate": "Duplikuj",
    "Uku task templates": "Szablony zadań Uku",
    "Are you sure that you want to delete this task template?": "Czy na pewno chcesz usunąć ten szablon zadania?",
    "Templates": "Szablony",
    "Overview": "Przegląd",
    "chat_app_overview_text": "<p class='title'>Uku Chat is a user-friendly and secure messaging tool tailored to streamline communication, collaboration, and task management.</p> <div class='body-2'><p>Key functionalities include:</p><ul><li>Real-time messaging: Send instant messages to team members and clients. It has options for direct messages, group chats, and dedicated channels for specific topics.</li><li>Task management: Create a new task from a conversation.</li><li>ChatGPT integration: Summarize the conversation, change the tone of voice, and request recommendations for response.</li><li>Customizable notifications: Tailor notifications to your preferences.</li></ul></div>",
    "Color": "Kolor",
    "Are you sure to delete this field? You may lose the data.": "Czy na pewno chcesz usunąć to pole? Możesz stracić dane.",
    "Add field": "Dodaj pole",
    "Add section": "Dodaj sekcję",
    "multiline": "multilinia",
    "Import data": "Zaimportuj dane",
    "Automate data collection with Smart Accounts": "Zautomatyzuj gromadzenie danych za pomocą Smart Accounts",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Importuj wpisy zakupów i sprzedaży, łączną liczbę wpisów i liczbę wierszy wejściowych;</li><li>Automatyzuj gromadzenie danych za pomocą Smart Accounts;</li><li>Szybsze i dokładniejsze rozliczanie dzięki automatycznej wymianie danych. Uku gromadzi informacje potrzebne do przygotowania faktur klientów w jednym miejscu i usprawnia fakturowanie.</li></ul>",
    "xero_app_overview_text": "<p class='title'>Automate your billing process by connecting Xero to Uku.</p> <div class='body-2'><p>Benefits of the Xero integration:</p><ul><li>Import all your clients from Xero to Uku with just a couple of clicks</li><li>Import product codes and classificators to Uku</li><li>Create invoices automatically in Uku and send them to Xero</li></ul></div>",
    "Import clients from {0}": "Zaimportuj klientów z {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Przed importem klientów musisz dokonać autoryzacji w Xero i wybrać Firmę.",
    "Authorize Xero to start import": "Autoryzuj Xero, aby rozpocząć import",
    "Failed to import clients": "Nie udało się zaimportować klientów",
    "Failed to connect to WS": "Nie udało się połączyć z WS",
    "Import": "Import",
    "emailing_app_overview_text": "<p class='title'><b>Fast and convenient client communication</b></p><div class='body-2'><p>Send one-time emails or set up automated emails. You can do both from the task view.</p><p><b>Automated emails</b></p><p>Add an automatic email to recurring tasks. For example, set up an automatic email \"Missing documents\" to the task \"Documents entry\" which will be sent out 2 days before the task starts. This way you have all necessary documents when starting working on the task.</p><p><b>Email templates</b></p><p>Save emails you often send conveniently as a template. This saves you the hassle of constantly composing messages with the same content.</p></div>",
    "Email signatures": "Email signatures",
    "Everyone": "Każdy",
    "Access": "Access",
    "Creator": "Kreator",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "Adresy e-mail",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku bezpiecznie integruje się z pocztą elektroniczną, aby pomóc Ci w zarządzaniu i automatyzacji komunikacji",
    "Use {0} address": "Użyj adresu {0}",
    "connect your email address": "połącz swój adres e-mail",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Połącz się z Microsoft Exchange lub innym serwerem poczty elektronicznej (SMTP)",
    "Email integration reconnected": "Ponownie połączono integrację poczty e-mail",
    "Are you sure you want to delete this email integration?": "Czy na pewno chcesz usunąć tę integrację mailową?",
    "Email templates": "Szablony e-maili",
    "Add email template": "Dodaj szablon e-maila",
    "Are you sure you want to save this template? Some tasks will be affected": "Czy na pewno chcesz zapisać ten szablon? Niektóre zadania zostaną zmienione",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "<p class='title'>Automate your billing process by connecting e-conomic to Uku</p><div class='body-2'><p>e-conomic integration enables you to:<ul><li>import all your clients from e-conomic to Uku with just a couple of clicks</li><li>import products and classificators from e-conomic to Uku</li><li>create invoices automatically in Uku and send them to e-conomic</li></ul></p></div>",
    "Default layout": "Domyślny układ",
    "Change agreement ID": "Zmień identyfikator zgody",
    "Failed to connect to server": "Nie udało się połączyć z serwerem",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "<div class='body-2'><p>Import the following data from e-conomic to Uku:<ul><li>clients,</li><li>products,</li><li>units,</li><li>layout templates.</li></ul></p><p>In the next step you’ll be able to select the clients you want to add or update.</p></div>",
    "Connect e-conomic": "Podłącz e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Przed importowaniem klientów należy połączyć oprogramowanie Uku i e-conomic. W tym celu należy utworzyć umowę e-conomic i wprowadzić tutaj identyfikator umowy.",
    "Step {0}": "Krok {0}",
    "Get agreement ID": "Zdobądź ID zgody",
    "Insert agreement ID": "Wstaw ID zgody",
    "Connect": "Połącz",
    "quickbooks_app_overview_text": "<p class='title'>Automate your billing process by connecting QuickBooks Online to Uku.</p> <div class='body-2'><p>Benefits of the QuickBooks integration:</p><ul><li>Import all your clients from QuickBooks to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to QuickBooks.</li></ul></div>",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku zaimportuje wszystkich klientów, informacje o klientach i klasyfikatorów z QuickBooks. W ostatnim kroku możesz wybrać klientów, których chcesz dodać lub zaktualizować.",
    "Before importing clients, you need to connect with QuickBooks.": "Przed zaimportowaniem klientów musisz połączyć się z QuickBooks.",
    "Connected to QuickBooks": "Połączony z QuickBooks",
    "fortnox_app_overview_text": "<p class='title'>Automate your billing process by connecting Fortnox to Uku.</p> <div class='body-2'><p>Benefits of the Fortnox integration:</p><ul><li>Import all your clients from Fortnox to Uku with just a couple of clicks.</li><li>Import products and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Fortnox.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku zaimportuje wszystkich klientów, informacje o klientach i klasyfikatory z Fortnox. W ostatnim kroku możesz wybrać klientów, których chcesz dodać lub zaktualizować.",
    "Before importing clients, you need to connect with Fortnox.": "Przed zaimportowaniem klientów musisz połączyć się z Fortnox.",
    "Connect to Fortnox": "Połącz się z Fortnox",
    "Connected to Fortnox": "Połączony z Fortnox",
    "Delete template": "Usuń szablon",
    "Public": "Publiczne",
    "Workflow templates": "Szablony cyklu pracy",
    "No workflow templates yet": "Nie ma jeszcze szablonu cyklu pracy",
    "Modified": "Zmodyfikowano",
    "Uku workflow templates": "Szablony przepływu pracy Uku",
    "Are you sure you wish to delete this workflow?": "Czy na pewno chcesz usunąć ten cykl pracy?",
    "Project fields": "Pola projektowe",
    "Progress step": "Krok postępu",
    "Rename project": "Zmień nazwę projektu",
    "Project statuses": "Statusy projektu",
    "You can use the statuses to restrict the workflow.": "Możesz użyć statusów do ograniczenia cyklu pracy.",
    "Project phases": "Fazy projektu",
    "Make your progress beautiful.": "Spraw, aby Twój postęp był wspaniały.",
    "Permissions": "Zezwolenia",
    "Users can manage workflow templates": "Użytkownicy mogą zarządzać szablonami cyklu pracy",
    "project_app_overview_text": "Handle projects from initiation to completion with ease.",
    "project_app_overview_description": "<div class=‘body-2’><p>Plan and execute tasks, track your projects, and never have a task fall through the cracks.</p><p>Key features:</p><ul><li><b>Creating projects: </b>Create projects using ready-made, customisable project templates. Keep non-accounting projects like client or employee onboarding separate from daily tasks. You can also start projects from scratch to tailor projects precisely to your needs.</li><li><b>Task management: </b>Break projects into tasks, assign responsibilities, and set due dates and dependencies. Separate extra services from daily accounting tasks.</li><li><b>Progress tracking: </b>The interactive project overview helps visualise progress, allowing for effective project schedule management. For instance, project tasks, like onboarding and off-boarding templates, look different from your regular tasks.</li><li><b>Customisation: </b>Tailor projects to your organisation’s needs with customisable fields and workflow templates. Have tasks depend on the project’s start or due date rather than a specific date of the month, providing flexibility and adaptability to project management.</li></ul></div>",
    "Configure summary task": "Skonfiguruj zadanie sumaryczne",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku wygeneruje zadanie z następującym tytułem i tematem ostatniego dnia miesiąca.",
    "Task title": "Tytuł zadania",
    "Recurrence": "Cykl",
    "Count changes from previous periods": "Zmiany liczby w stosunku do poprzednich okresów",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Jeśli opcja ta jest włączona, zmiany dokonane w poprzednich okresach zostaną dodane do bieżącego miesiąca. Jeśli opcja ta jest wyłączona, zmiany dokonane w poprzednich okresach nie będą uwzględniane.",
    "Configure data fields": "Skonfiguruj pola danych",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Wybierz odpowiednie pole Uku dla każdego importowanego pola. Te same pola zostaną podsumowane. Pozostawiając puste pole, zostanie zignorowane.",
    "New custom field": "Nowe niestandardowe pole",
    "Show more": "Pokaż więcej",
    "Every month": "Każdego miesiąca",
    "Last day of the month": "Ostatni dzień miesiąca",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Dzień {0} następnego miesiąca",
    "Settings saved": "Ustawienia zapisane",
    "Uku will let you know when it is ready.": "Uku poinformuje cię, kiedy będzie gotowy.",
    "Reload data": "Przeładuj dane",
    "months": "miesięcy",
    "This will overwrite existing summary tasks new values.": "Spowoduje to nadpisanie istniejących zadań podsumowania nowymi wartościami.",
    "Overwrite": "Nadpisz",
    "Automate your anti money laundering process": "Zautomatyzuj proces przeciwdziałania praniu pieniędzy",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Zaraz aktywujesz proces przeciwdziałania praniu brudnych pieniędzy. W tym czasie do danych Twoich klientów zostaną dodane nowe pola, a system zacznie przypominać Ci o ich aktualizacji.<br><br>Dodatkowe pola to:<ul><li>Profil ryzyka</il><li>Profil ważny do</il><li>Status AML</il><li>Dokument NR</il><li>Dokument ważny do</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Zaraz aktywujesz proces przeciwdziałania praniu brudnych pieniędzy. W tym czasie do danych Twoich klientów zostaną dodane nowe pola, a system zacznie przypominać Ci o ich aktualizacji.<br><br>Dodatkowe pola to:<ul><li>Profil ryzyka</il><li>Następne sprawdzanie AML</il><li>Powodzenie/Niepowodzenie</il><li>Typ ID</il><li>Numer ID</il><li>Data wygaśnięcia</il><li>Dodatkowe kontrole</il><li> li></ul>",
    "Do not change client custom fields created by Uku": "Nie zmieniaj niestandardowych pól klienta utworzonych przez Uku",
    "day(s) before": "dzień/dni przed",
    "Task name": "Nazwa zadania",
    "Assigned": "Przydzielony",
    "Note": "Notatka",
    "Manual run": "Uruchamianie ręczne",
    "Create a task when the document expires": "Utwórz zadanie, gdy dokument wygaśnie",
    "Create a task when the risk profile must be updated": "Utwórz zadanie, gdy profil ryzyka musi zostać zaktualizowany",
    "Flextime period": "Okres elastycznego czasu pracy",
    "Confirmation period": "Confirmation period",
    "Weekly": "Co tydzień",
    "Add agreement": "Dodaj zgodę",
    "flextime_app_overview_text": "<p class='title'>Get an overview of your team's working hours, overtime, and vacation balance.</p> <div class='body-2'><p></p><p>Flextime benefits:</p><ul><li>Convenient overview of work and overtime</li><li>Accessible vacation management and balance overview</li><li>Easy data export for your accountant</li></ul></div>",
    "supplier_app_overview_text": "Manage your partners and vendors.",
    "supplier_app_overview_description": "<div class='body-2'><p>Your partners and third party organisations can be managed here in a separate register. You will no longer have to keep a list of contacts in an Excel sheet.</p></div>",
    "Supplier type": "Typ dostawcy",
    "Parent type": "Typ rodzica",
    "Edit supplier type": "Edytuj typ dostawcy",
    "New supplier type": "Nowy typ dostawcy",
    "Are you sure you wish to delete this supplier type?": "Czy na pewno chcesz usunąć ten typ dostawcy?",
    "Types": "Typy",
    "Supplier types": "Typy dostawców",
    "No supplier types yet": "Nie ma jeszcze typów dostawców",
    "tripletex_app_overview_text": "<p class='title'>Automate your billing process by connecting Tripletex to Uku.</p> <div class='body-2'><p>Benefits of the Tripletex integration:</p><ul><li>Import all your clients from Tripletex to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Tripletex.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku zaimportuje wszystkich klientów, informacje o klientach i klasyfikatory z Tripletex. W ostatnim kroku możesz wybrać klientów, których chcesz dodać lub zaktualizować.",
    "Connect Tripletex": "Połącz Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Przed zaimportowaniem klientów musisz połączyć Uku i oprogramowanie Tripletex. Aby to zrobić, utwórz token pracownika i wprowadź go tutaj.",
    "Get employee token": "Pobierz token pracownika",
    "Insert employee token": "Wstaw token pracownika",
    "Install": "Zainstaluj",
    "Open Chrome browser to install": "Otwórz przeglądarkę Chrome, aby zainstalować",
    "Works with your online accounting software.": "Współpracuje z oprogramowaniem księgowym online.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Nowe zadania mogą pojawiać się błyskawicznie, dlatego Mini Uku jest Twoim najlepszym przyjacielem. Bez względu na to, czy robisz przelewy bankowe, czy pracujesz w swoim oprogramowaniu księgowym; z Mini Uku możesz dodawać nowe zadania, śledzić czas i wszystkie powiadomienia z dowolnej strony internetowej.<br><br>Wystarczy jedno kliknięcie na ikonę sowy, aby uzyskać przegląd całego dnia pracy i pomóc wydajniej zaplanować harmonogram.",
    "merit_aktiva_app_overview_text_pl": "<p class='title'>Importuj klientów i ilość pracy, aby otrzymać jeden raport z danymi dotyczącymi wykonanej pracy dla wszystkich klientów.</p><div class='body-2'><p>Spraw, aby zbieranie danych było szybkie i dokładne dzięki integracji 360 Księgowość i Uku. Uku automatycznie importuje faktury sprzedaży i zakupu, dokumenty, wpisy, itd. dla każdego klienta i zbiera nakład pracy oraz wpisy czasowe w jednym, interaktywnym raporcie. Koniec z przełączaniem się między klientami w oprogramowaniu księgowym w celu uzyskania informacji o przetworzonych dokumentach, aby utworzyć faktury lub monitorować wydajność klienta. W porównaniu do 360 Księgowość, Uku importuje rzeczywistą liczbę wpisów z ostatniego miesiąca, biorąc pod uwagę wszystkie zmiany, które zostały wprowadzone do poprzednich okresów. Oznacza to, że nie musisz zapamiętywać ani zapisywać żadnych zmian, które wprowadziłeś - Uku ma wszystkie te informacje i Ty też będziesz je mieć. Zautomatyzowane zbieranie danych oszczędza Twój czas i eliminuje błąd ludzki.</p><p>Integracja Uku i 360 Księgowość pomaga Ci:</p><p><ul><li>Szybko i dokładnie zbierać dane - ilość pracy jest automatycznie importowana do Uku z 360 Księgowość</li><li>Analizować obciążenie pracą i czas dzięki dostępowi do pełnego podsumowania wykonanej pracy i czasu spędzonego na klientach</li><li>Zautomatyzować tworzenie zestawień miesięcznych</li><li>Uzyskać przegląd rzeczywistego obciążenia pracą w każdym miesiącu</li></ul></p><p>Dzięki integracji Uku - 360 Księgowość możesz zaimportować:</p><p><ul><li>Dokumenty</li><li>Wpisy</li><li>Faktury przedaży</li><li>Faktury kupna</li><li>Operacje bankowe</li><li>Operacje gotówkowe</li><li>Wpisy VAT</li><li>Zapisy zasobów</li><li>Itd.</li></ul></p></div>",
    "merit_aktiva_app_overview_text": "<p class='title'>Importuj klientów i ilość pracy, aby otrzymać jeden raport z danymi dotyczącymi wykonanej pracy dla wszystkich klientów.</p><div class='body-2'><p>Spraw, aby zbieranie danych było szybkie i dokładne dzięki integracji 360 Księgowość i Uku. Uku automatycznie importuje faktury sprzedaży i zakupu, dokumenty, wpisy, itd. dla każdego klienta i zbiera nakład pracy oraz wpisy czasowe w jednym, interaktywnym raporcie. Koniec z przełączaniem się między klientami w oprogramowaniu księgowym w celu uzyskania informacji o przetworzonych dokumentach, aby utworzyć faktury lub monitorować wydajność klienta. W porównaniu do 360 Księgowość, Uku importuje rzeczywistą liczbę wpisów z ostatniego miesiąca, biorąc pod uwagę wszystkie zmiany, które zostały wprowadzone do poprzednich okresów. Oznacza to, że nie musisz zapamiętywać ani zapisywać żadnych zmian, które wprowadziłeś - Uku ma wszystkie te informacje i Ty też będziesz je mieć. Zautomatyzowane zbieranie danych oszczędza Twój czas i eliminuje błąd ludzki.</p><p>Integracja Uku i 360 Księgowość pomaga Ci:</p><p><ul><li>Szybko i dokładnie zbierać dane - ilość pracy jest automatycznie importowana do Uku z 360 Księgowość</li><li>Analizować obciążenie pracą i czas dzięki dostępowi do pełnego podsumowania wykonanej pracy i czasu spędzonego na klientach</li><li>Zautomatyzować tworzenie zestawień miesięcznych</li><li>Uzyskać przegląd rzeczywistego obciążenia pracą w każdym miesiącu</li></ul></p><p>Dzięki integracji Uku - 360 Księgowość możesz zaimportować:</p><p><ul><li>Dokumenty</li><li>Wpisy</li><li>Faktury przedaży</li><li>Faktury kupna</li><li>Operacje bankowe</li><li>Operacje gotówkowe</li><li>Wpisy VAT</li><li>Zapisy zasobów</li><li>Itd.</li></ul></p></div>",
    "Import clients": "Importuj klientów",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "You are about to disconnect this service.": "You are about to disconnect this service.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Odśwież",
    "Be aware of the issues before they become problems": "Wiedz o problemach, zanim staną się problemami",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Porównanie umowy z klientem w czasie rzeczywistym i faktycznie wykonanej pracy;</li> <li>Wiedz o problemach, zanim staną się problemami;</li> <li>Nawet przy stałych cenach musisz mieć wewnętrzne pomiary. Monitoruj ważność umowy klienta, porównując ją z rzeczywistą ilością wykonanej pracy.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku's Client Portal improves your service by simplifying communication between accountants and clients. With Uku's Client Portal, you can speed up communication, reduce email dependency, and offer a secure document-sharing and communication platform.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Client Portals features include:</p><ul><li><b>Magic Links:</b> Client's hassle-free login without usernames and passwords.</li><li><b>Document Digitisation:</b> Submit items to your accounting software with one click.</li><li><b>Client Communication:</b> Assign tasks to clients and send messages fast.</li><li><b>Automatic Reminders:</b> Reduce the amount of manual follow-ups, check statuses: seen, done.</li><li><b>Multilingual Interface:</b> Supports multiple languages for a personalised experience.</li><li><b>Customisable Branding:</b> Add logos, icons, colours and a welcome video to make your clients feel at home.</li></ul><p></p><p>Some Client Portal use cases:</p><p><b>1. Get Client Information:</b></p><ul><li>Add recurring tasks with document requirements.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Clients upload documents and answer queries in the Client Portal.</li></ul><p></p><p><b>2. Make Finance Reviews:</b></p><ul><li>Add monthly recurring tasks with meeting links.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Send the client a meeting memo with a recorded video.</li></ul><p></p><p><b>3. Onboard Your Client:</b></p><ul><li>Add an onboarding task from the template.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>The client fills out the checklist (accesses, reports).</li></ul><p></p><p>These use cases demonstrate Uku's Client Portal's task management and communication efficiency.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Read more &rsaquo;</a></p></div>",
    "Branding": "Branding",
    "Subdomain": "Subdomena",
    "Default language": "Domyślny język",
    "Client portal URL in other languages": "Adres URL portalu klienta w innych językach",
    "Copy URL": "Kopiuj adres URL",
    "Trademark": "Znak towarowy",
    "Trademark text color": "Kolor tekstu znaku towarowego",
    "Choose color": "Wybierz kolor",
    "Brand background color": "Kolor tła marki",
    "Logo": "Logo",
    "Delete logo": "Usuń logo",
    "Upload logo file": "Prześlij plik logo",
    "Max. dimensions 180 x 60 px": "Maksymalne wymiary 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Usuń ikonę",
    "Upload icon file": "Prześlij plik ikony",
    "Recommended size 260 x 260 px": "Zalecany rozmiar 260 x 260 pikseli",
    "Company description": "Opis firmy",
    "Displayed on the login page.": "Wyświetlane na stronie logowania.",
    "Describe here what services you offer and how you help your clients.": "Opisz tutaj, jakie usługi oferujesz i w jaki sposób pomagasz swoim klientom.",
    "Welcome video": "Powitalne wideo",
    "Displayed on the login page when your client contact enters for the first time": "Wyświetlane na stronie logowania, gdy Twój klient wchodzi po raz pierwszy",
    "Use Uku video": "Użyj wideo Uku",
    "View": "Pogląd",
    "Use other video": "Użyj innego wideo",
    "Youtube or Vimeo video URL": "Link do wideo z Youtube lub Vimeo",
    "Show file upload box for client tasks": "Pokaż pole przesyłania plików dla zadań klienta",
    "Invalid data": "Nieprawidłowe dane",
    "Client portal preview": "Podgląd portalu klienta",
    "Client portal URL for {0} copied to clipboard": "Adres URL portalu klienta dla {0} skopiowany do schowka",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Add recurring task": "Dodaj zadanie cykliczne",
    "Reminder tasks updated": "Zaktualizowano zadania przypomnień",
    "Create recurring tasks for Companies House clients.": "Twórz powtarzające się zadania dla klientów Companies House.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "przyciski",
    "Show to me": "Pokaż mi",
    "magic_button_app_overview_text": "<p class='title'>Za pomocą jednego kliknięcia dodaj nowe zadanie i uruchom czasomierz.</p><div class='body-2'><p>Magiczne przyciski umożliwiają wygodne dodawanie pilnych zadań (telefony, e-maile).</p><p>Natychmiast dodaj wszystkie zadania do Uku</p><p>Magiczne przyciski pozwalają na wygodne dodanie pilnych zadań (telefony, e-maile) do Uku. Dzięki temu zadania są prawidłowo dodawane do Uku.</p><p>Magiczne przyciski:</p><p><ul><li>Dodaj nowe zadanie i uruchom czasomierz za pomocą jednego kliknięcia (przejdź do + przycisk w nagłówku).</li><li>Dostosuj magiczne przyciski do swoich potrzeb.</li><li>Później zmodyfikuj klienta lub inne informacje.</li><li>Kontynuuj poprzednie zadanie, do którego możesz szybko uzyskać dostęp z listy magicznych przycisków.</li></ul><p></div>",
    "Buttons": "Przyciski",
    "Member rights": "Prawa członkowskie",
    "Allow managers to view and create their client contracts and invoices": "Pozwól menedżerom przeglądać i tworzyć umowy z klientami i faktury",
    "Allow members to view and create their client invoices": "Pozwól członkom przeglądać i tworzyć faktury swoich klientów",
    "Allow members to view their client invoices": "Zezwalaj członkom na przeglądanie faktur klientów",
    "Allow only owners to add and update products": "Pozwól, aby tylko właściciele mogli dodawać i aktualizować produkty",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Zezwalaj członkom na potwierdzanie wierszy faktur klientów",
    "Send PDF invoice": "Wyślij fakturę PDF",
    "Invoice email": "E-mail z fakturą",
    "Default rounding": "Domyślne zaokrąglenie",
    "Round all times up to x": "Zaokrąglij wszystkie czasy do x",
    "Time rounding increment": "Przyrost zaokrąglenia czasu",
    "Apply time rounding to": "Zastosuj zaokrąglenie czasu do",
    "Default configuration": "Konfiguracja domyślna",
    "Invoice date": "Data faktury",
    "Invoice entry date": "Data wprowadzenia faktury",
    "Bill tracked time by": "Bill śledził czas poprzez",
    "Bill task field by": "Ustaw pole zadania według",
    "Create one invoice merging invoices from the same period": "Utwórz jedną fakturę łączącą faktury z tego samego okresu",
    "Invoices from the same period": "Faktury z tego samego okresu",
    "Hide zero sum lines": "Ukryj linie o sumie zerowej",
    "By default, time entry is billable": "Domyślnie wprowadzanie czasu jest rozliczane",
    "Invoice number": "Numer faktury",
    "Prefix": "Przedrostek",
    "Suffix": "Przyrostek",
    "Google Gmail": "Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Zapisano ustawienia płatności",
    "billing_app_overview_text": "<p class='title'>Przyspiesz proces rozliczania klientów dzięki elastycznym cennikom i inteligentnym kontaktom.</p><div class='body-2'><p>Zautomatyzuj proces fakturowania i zaoszczędź cenny czas na generowaniu faktur. Dynamiczne rozliczanie Uku przygotowuje wszystkie Twoje faktury na podstawie wykonanej pracy i pomaga uzyskać uczciwy zysk od klientów. Koniec ze zbieraniem danych z różnych programów lub arkuszy Excel - Uku ma w sobie wszystko i przygotowuje dla Ciebie faktury. Tobie pozostaje tylko przejrzenie i wysłanie faktur.</p><p>Fakturowanie Uku:</p><p><ul><li><b>Oszczędza czas</b> skracając godziny pracy administracji</li><li><b>Zwiększa przychody,</b>  przygotowując faktury na podstawie całej wykonanej pracy</li><li><b>Zmniejsza wskaźniki błędów / pozwala uniknąć nieprawidłowego fakturowania,</b> minimalizując interwencję człowieka</li><li><b>Zapewnia stały strumień przychodów</b> z bardziej terminowym rozliczaniem</li><li><b>Zwiększa przejrzystość</b> dzięki szczegółowym i łatwo dostępnym umowom z klientami</li><li><b>Zwiększa dokładność,</b> poprzez zapamiętywanie wszystkich zmian w umowach już od 1 dnia</li><li><b>Zapewnia elastyczność, skalowalność</b> i zapewnia Twoim klientom lepsze doświadczenia</li></ul></p><p>Uku obsługuje wszystkie rodzaje modeli cenowych - pomożemy Ci bez względu na to, jakie umowy zawarłeś ze swoimi klientami. Fakturowanie Uku umożliwia tworzenie produktów, w tym:</p><p><ul><li>Stawka godzinowa (np. stawka księgowego, stawka asystenta)</li><li>Stawka stała (np. pakiety, stawka uzgodniona corocznie)</li><li>Cena według wartości  (np. postrzegana wartość usług)</li><li>Cena według ilości pracy ( np. ilość przetworzonych dokumentów)</li><li>Cena dodatkowych usług  (np. rozliczenia roczne, konsultacje)</li><li>Połączenie kilku modeli (np. stawka stała + nadgodziny; ilość pracy + godziny konsultacji; itd.)</li></ul></p><p>Po utworzeniu faktur przez Uku możesz je przeglądać, wprowadzać zmiany (jeśli to konieczne) i wysyłać faktury zbiorczo.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' target='_blank'>Dowiedz się więcej o fakturowaniu Uku tutaj.</a> </p><p>Jeżeli chcesz wprowadzić fakturowanie Uku i chcesz porozmawiać z naszym ekspertem,  <a href='https://calendly.com/getuku/uku-billing' target='_blank'>zarezerwuj termin tutaj </a> (bezpłatnie).</p></div>",
    "Products": "Produkty",
    "Contract templates": "Szablony umów",
    "Invoice templates": "Szablony faktur",
    "Tools": "Narzędzia",
    "Replace tax": "Zastąp podatek",
    "Old tax": "Stary podatek",
    "New tax": "Nowy podatek",
    "Find tax": "Znajdź podatek",
    "Replace VAT in products": "Zamień podatek VAT na produkty",
    "Replace VAT in master contracts": "Zamień podatek VAT we wzorach umów",
    "Replace VAT in client contracts & draft invoices": "Zamień podatek VAT w umowach z klientami i projektach faktur",
    "Replace VAT values": "Zamień wartości podatku VAT",
    "This action cannot be undone": "Tej akcji nie można cofnąć",
    "Replace": "Zastąp",
    "Result": "Rezultat",
    "PDF templates": "Szablony PDF",
    "E-mail templates": "Szablony e-maili",
    "Edit PDF template": "Edytuj szablon PDF-a",
    "Import classificators": "Importuj klasyfikatory",
    "products": "produkty",
    "product": "produkt",
    "Product / service": "Produkt/usługa",
    "Calculate": "Policz",
    "Article": "Artykuł",
    "Resource": "Zasób",
    "Cost center": "Centrum kosztów",
    "Taxes": "Podatki",
    "Code": "Kod",
    "Source": "Źródło",
    "Articles": "Artykuły",
    "Resources": "Zasoby",
    "Cost centers": "Centra kosztów",
    "Units": "Jednostki",
    "Unit": "Jednostka",
    "Bank accounts": "Konta bankowe",
    "Bank account": "Konto bankowe",
    "Bank name": "Nazwa banku",
    "IBAN": "IBAN",
    "SWIFT code": "Kod SWIFT/BIC",
    "Do you wish to import only new data or also overwrite existing?": "Czy chcesz zaimportować tylko nowe dane, czy również nadpisać istniejące?",
    "Only new": "Tylko nowe",
    "New items will be added. Existing ones will remain unchanged by import.": "Dodane zostaną nowe elementy. Istniejące elementy pozostaną niezmienione przez import.",
    "Import everything": "Importuj wszystko",
    "Connect accounting service": "Połącz usługę księgową",
    "Service": "Usługa",
    "API ID": "API ID",
    "API key": "Klucz API",
    "Company Account Id": "ID konta firmowego",
    "Api secret": "API Secret",
    "E-conomic": "E-conomic",
    "SmartAccounts": "SmartAccounts",
    "Test": "Test",
    "Lock time entries": "Zablokuj wpisy czasu",
    "Owner rights": "Prawa właściciela",
    "Disable company settings edit for all members": "Wyłącz edycję ustawień firmy dla wszystkich członków",
    "Disable personal clients for members": "Wyłącz klientów osobistych dla członków",
    "Show member birthdays": "Pokaż daty urodzin członków",
    "Show contact birthdays": "Pokaż daty urodzin kontaktów",
    "Weekly @ Sun {0}": "Weekly @ Sun {0}",
    "Monthly @ last day of month": "Miesięcznie @ ostatni dzień miesiąca",
    "Company event list": "Lista wydarzeń firmowych",
    "How long?": "Jak długo?",
    "Invoice no.": "Nr faktury",
    "Login options": "Opcje logowania",
    "Tenant ID (optional)": "Tenant ID (opcjonalny)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Dodaj identyfikator dzierżawy Active Directory, jeśli tylko użytkownicy należący do tej dzierżawy mogą się łączyć",
    "How to find ID’s?": "Jak znaleźć identyfikatory?",
    "Microsoft connected": "Microsoft podłączony",
    "Google connected": "Google połączone",
    "Edit company": "Edytuj firmę",
    "Timezone": "Strefa czasowa",
    "VAT number": "NIP",
    "Company number": "REGON",
    "Subscription plan": "Plan abonamentowy",
    "Payment failed": "Płatność zakończona błędem",
    "Retry payment": "Ponów płatność",
    "Next payment": "Następna płatność",
    "Update payment method": "Zaktualizuj metodę płatności",
    "Plan": "Plan",
    "Choose a plan": "Wybierz plan",
    "Change plan": "Zmień plan",
    "{0}-day free trial until {1}": "{0}-dniowy bezpłatny okres próbny do {1}",
    "monthly": "miesięczny",
    "yearly": "roczny",
    "{0} member": "{0} członek",
    "{0} members": "{0} członków",
    "{0} plan": "{0} plan",
    "Cancelled (valid until {0})": "Anulowane (ważne do {0})",
    "Your trial expired on {0}": "Twój okres próbny wygasł w dniu {0}",
    "Your subscription expired on {0}": "Twoja subskrypcja wygasła w dniu {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Miło Cię widzieć! Jeśli chcesz rozpocząć korzystanie z subskrypcji Uku, kliknij Wybierz plan",
    "Save {0} by paying for a year!": "Zaoszczędź {0}, płacąc za rok!",
    "Choose plan": "Wybierz plan",
    "Pay annually": "Płać corocznie",
    "Instructions sent!": "Instrukcje wysłane!",
    "Instructions for resetting your password have been sent to": "Instrukcje dotyczące resetowania hasła zostały wysłane do",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Otrzymasz tę wiadomość w ciągu 5 minut. Sprawdź też folder ze spamem.",
    "Back to login page": "Powrót do strony logowania",
    "Get new password": "Uzyskaj nowe hasło",
    "Pick a password": "Wybierz hasło",
    "Use minimum 8 characters with letters & numbers": "Użyj minimum 8 znaków z literami i cyframi",
    "Create your Uku Account": "Utwórz swoje konto Uku",
    "Connect your Xero Account": "Połącz swoje konto Xero",
    "Phone": "Telefon",
    "I agree to the": "Zgadzam się z",
    "Terms of Service": "Regulaminem",
    "Next": "Dalej",
    "Having trouble?": "Masz problemy?",
    "We can help": "Możemy pomóc",
    "Log in instead": "Zaloguj się zamiast tego",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Narzędzie nr 1 dla praktyk księgowych. Zautomatyzowane przepływy pracy, śledzenie czasu, raporty, monitoring, CRM. Wykonuj pracę na czas i z zyskiem. Wypróbuj za darmo!",
    "You are invited to join": "Zapraszamy do przyłączenia się",
    "Accept invitation": "Przyjmij zaproszenie",
    "Check your email": "Sprawdź swój email",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Wysłałem Ci e-mail z linkiem do aktywacji konta. Jest to ważne, aby zapewnić bezpieczeństwo Twojego konta.",
    "Go to": "Przejdź do",
    "Need a new password?": "Potrzebujesz nowego hasła?",
    "Enter your e-mail address and we will send you directions for changing your password": "Wpisz swój adres e-mail, a my wyślemy Ci wskazówki dotyczące zmiany hasła",
    "Send me instructions": "Wyślij mi instrukcje",
    "Never mind, go back": "Nieważne, wróć",
    "No login options enabled. Please contact the company owner": "Nie włączono opcji logowania. Skontaktuj się z właścicielem firmy",
    "Log in to Uku": "Zaloguj się do Uku",
    "Forgot password?": "Zapomniałeś hasła?",
    "Don't have account?": "Nie masz konta?",
    "Create account": "Utwórz konto",
    "Total items:": "Wszystkie pozycje:",
    "Add new": "Dodaj nowe",
    "Amount": "Ilość",
    "Account created range": "Zakres utworzony na koncie",
    "Usage limit": "Limit użytkowania",
    "Valid until": "Ważne do",
    "Edit help link": "Edytuj link pomocy",
    "New help link": "Nowy link pomocy",
    "Name key": "Klucz nazwy",
    "Country code": "Kod kraju",
    "Period (months)": "Okres (miesiące)",
    "Account created from": "Konto utworzone od",
    "Account created until": "Konto utworzone do",
    "Used count": "Liczba używanych",
    "Sum": "Suma",
    "Create voucher": "Utwórz kupon",
    "Edit voucher": "Edytuj kupon",
    "Are you sure to delete this voucher?": "Czy na pewno chcesz usunąć ten kupon?",
    "row | rows": "rząd | rzędy",
    "Add event": "Dodaj wydarzenie",
    "Are you sure you wish to delete this event?": "Czy na pewno chcesz usunąć to wydarzenie?",
    "event | events": "wydarzenie | wydarzenia",
    "Security object id": "ID obiektu bezpieczeństwa",
    "Direct rights": "Prawa bezpośrednie",
    "Computed rights": "Prawa wyliczane",
    "Add link": "Dodaj link",
    "Are you sure you wish to delete this entry?": "Czy na pewno chcesz usunąć ten wpis?",
    "link | links": "odnośnik | odnośniki",
    "Event type": "Typ wydarzenia",
    "Date from": "Data od",
    "Date until": "Data do",
    "Shortened by h": "Skrócony przez h",
    "Category": "Kategoria",
    "demo | demos": "demo | dema",
    "Companies": "Firmy",
    "Leads": "Leady",
    "Demos": "Dema",
    "Vouchers": "Kupony",
    "KPI": "KPI",
    "Activity log": "Dziennik aktywności",
    "Notifications": "Powiadomienia",
    "Me": "Ja",
    "Important notifications will appear here.": "Tutaj pojawią się ważne powiadomienia.",
    "Back": "Powrót",
    "Return to UKU": "Powrót do UKU",
    "Choose plan for {0}": "Wybierz plan dla {0}",
    "First payment will be made after the end of the trial period.": "Pierwsza płatność zostanie dokonana po zakończeniu okresu próbnego.",
    "Members and subscription can always be changed.": "Członków i abonament zawsze można zmienić.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Okres rozliczeniowy",
    "Compare features": "Porównaj funkcje",
    "Cancel uku subscription": "Anuluj subskrypcję Uku",
    "{0} discount": "zniżka {0}",
    "You have currently<br />{0} active member": "Masz obecnie<br />{0} aktywnych użytkowników",
    "You have currently<br />{0} active members": "Masz obecnie<br />{0} aktywnych członków",
    "Select yearly plan": "Wybierz plan roczny",
    "Select monthly plan": "Wybierz abonament miesięczny",
    "Attention!": "Uwaga!",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Wybierz abonament {0}",
    "per member/month (billed yearly)": "za członka/miesiąc (rozliczanie roczne)",
    "or {0} per member/month (monthly)": "lub {0} za członka/miesiąc (miesięcznie)",
    "Everything in {0}, plus:": "Wszystko w {0}, plus:",
    "Compare plans, feature-by-feature": "Porównaj plany, funkcja po funkcji",
    "Deactivate account": "Dezaktywuj konto",
    "Are you sure to deactivate {0} account?": "Czy na pewno chcesz dezaktywować {0} konto?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Jeśli zdecydujesz się kontynuować plan dla freelancerów, Twoje konto firmowe zostanie dezaktywowane. Dane powiązane z tą firmą zostaną usunięte.",
    "Deactivate": "Dezaktywuj",
    "Teamwork": "Praca zespołowa",
    "Unlimited clients + import": "Nieograniczona liczba klientów + import",
    "Access management": "Zarządzanie dostępem",
    "Custom fields": "Własne pola",
    "Live chat support": "Obsługa czatu na żywo",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Portal klienta",
    "New!": "Nowość!",
    "Custom integrations": "Niestandardowe integracje",
    "Assisted clients import": "Wspomagany import klientów",
    "Tailor-made team workshop": "Warsztat zespołowy dostosowany do potrzeb klienta",
    "Early access to features": "Wczesny dostęp do funkcji",
    "Pay by invoice": "Płatność za pomocą faktury",
    "Dedicated account manager": "Dedykowany menedżer konta",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Cześć! Twój okres próbny się skończył. Prosimy wybrać plan abonamentowy {0}, aby kontynuować pracę.",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Cześć! Musisz uaktualnić plan abonamentowy {0}, aby korzystać z tej funkcji.",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "Edit VAT number": "Edit VAT number",
    "VAT": "VAT",
    "This is subscription period amount.": "Jest to kwota okresu subskrypcji.",
    "You save yearly {0}": "Oszczędzasz rocznie {0}",
    "Add voucher": "Dodaj kupon",
    "Existing credit": "Istniejący kredyt",
    "Current payment": "Bieżąca płatność",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Jest to bieżąca kwota płatności. Twój bank wymaga również potwierdzenia kwoty okresu subskrypcji.",
    "Confirm subscription {0}": "Potwierdź subskrypcję {0}",
    "Your subscription will renew on": "Twoja subskrypcja odnowi się w dniu",
    "Thank you for believing in us!": "Dziękujemy, że w nas wierzysz!",
    "Uku team": "Zespół Uku",
    "Voucher {1} (-{0}%)": "Voucher {1} (-{0}%)",
    "Voucher {0}": "Kupon {0}",
    "New plan": "Nowy plan",
    "Changed plan": "Zmieniony plan",
    "Add {0} member": "Dodaj {0} członka",
    "Add {0} members": "Dodaj {0} członków",
    "Remove {0} member": "Usuń {0} członka",
    "Remove {0} members": "Usuń {0} członków",
    "No changes to plan": "Brak zmian w planie",
    "Discount -{0}% with Yearly subscription": "Rabat -{0}% przy subskrypcji rocznej",
    "Yearly discounted price (-{0}%)": "Roczna cena zdyskontowana (-{0}%)",
    "Subscription updated": "Aktualizacja subskrypcji",
    "Please wait": "Proszę czekać",
    "Your payment failed": "Twoja płatność nie powiodła się",
    "Please check that you entered the data correctly or use another card": "Sprawdź poprawność wpisanych danych lub użyj innej karty",
    "Try again": "Spróbuj ponownie",
    "Pay": "Zapłać",
    "Payment": "Zapłata",
    "Payment method updated": "Zaktualizowano metodę płatności",
    "Edit member": "Edytuj członka",
    "First name": "Imię",
    "Last name": "Nazwisko",
    "External ID": "Identyfikator zewnętrzny",
    "Select groups": "Wybierz grupy",
    "Administrator": "Administrator",
    "Invite sent": "Zaproszenie wysłane",
    "Activate member": "Aktywuj członka",
    "Deactivate member": "Dezaktywacja członka",
    "Invited": "Zaproszony",
    "Paid member": "Płatny członek",
    "Send an invitation": "Wyślij zaproszenie",
    "Limited": "Ograniczone",
    "No invite, no access": "Brak zaproszenia, brak dostępu",
    "Free until activated": "Bezpłatnie do momentu aktywacji",
    "No access, no charge": "Brak dostępu, brak opłat",
    "Hidden member": "Ukryty członek",
    "Edit members": "Edytuj członków",
    "Select user": "Wybierz użytkownika",
    "Member will be assigned to every selected client": "Członek zostanie przypisany do każdego wybranego klienta",
    "Member will be removed from all selected clients": "Członek zostanie usunięty ze wszystkich wybranych klientów",
    "Assign user": "Przypisz użytkownika",
    "Set as primary user": "Ustaw jako głównego użytkownika",
    "Added as a default user when adding a task plan": "Dodany jako domyślny użytkownik podczas dodawania planu zadań",
    "Remove from new tasks": "Usuń z nowych zadań",
    "Remove from plan tasks": "Usuń z planu zadań",
    "Remove": "Usuń",
    "Admin": "Administrator",
    "Remove user": "Usuń użytkownika",
    "Assign to incomplete tasks": "Przypisz do niekompletnych zadań",
    "Reassign incomplete tasks": "Ponownie przydziel niekompletne zadania",
    "Assign to plan tasks": "Przypisz do planu zadań",
    "Reassign plan tasks": "Ponownie przydziel do planu zadań",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Właściciel zostanie przypisany do zadań, jeśli usunięty użytkownik był ostatnim przypisanym użytkownikiem.",
    "Run integration": "Uruchom integrację",
    "Run": "Uruchom",
    "Integration configuration": "Konfiguracja integracji",
    "Read the manual": "Przeczytaj instrukcję",
    "Api key": "Klucz API",
    "Are you sure to delete this integration info?": "Czy na pewno chcesz usunąć te informacje o integracji?",
    "Edit Contracts": "Edytuj umowy",
    "Replace following contracts": "Zastąp następujące umowy",
    "Append services to following contracts": "Dołącz usługi do kolejnych umów",
    "Choose template": "Wybierz szablon",
    "Append only": "Tylko dołącz",
    "with template": "z szablonem",
    "All existing contracts": "Wszystkie istniejące umowy",
    "All quarterly contracts": "Wszystkie umowy kwartalne",
    "All monthly contracts": "Wszystkie umowy miesięczne",
    "All yearly contracts": "Wszystkie umowy roczne",
    "Next invoice number": "Numer następnej faktury",
    "Number is too big, it cannot exceed 15 digits": "Numer jest za duży, nie może przekraczać 15 cyfr",
    "Replace topic": "Zamień temat",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Wszystkie zadania i plany z bieżącym tematem zostaną zastąpione nowym wybranym tematem.",
    "Topics replaced": "Tematy zamienione",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Wszystkie zadania z tematem `{0}` zostaną zastąpione `{1}`. To nie jest odwracalne. Jesteś pewien?",
    "Name of topic": "Nazwa tematu",
    "Change topic": "Zmień temat",
    "Add new topic": "Dodaj nowy temat",
    "This topic is in use. Do you wish to archive it?": "Ten temat jest w użyciu. Czy chcesz go zarchiwizować?",
    "Are you sure that you want to delete this topic?": "Czy na pewno chcesz usunąć ten temat?",
    "These items will be deleted permanently": "Te elementy zostaną trwale usunięte",
    "Are you sure that you want to delete this client group?": "Czy jesteś pewien, że chcesz usunąć tę grupę klientów?",
    "This client group is in use. Do you wish to archive it?": "Ta grupa klientów jest w użyciu. Czy chcesz ją zarchiwizować?",
    "Edit client group": "Edytuj grupę klientów",
    "New client group": "Nowa grupa klientów",
    "Price": "Cena",
    "Quantity": "Ilość",
    "Unit will be translated to client language": "Jednostka zostanie przetłumaczona na język klienta",
    "Pick date & time": "Wybierz datę i godzinę",
    "Share equally": "Dziel się po równo",
    "Change existing": "Zmień istniejące",
    "Choose bookmark": "Wybierz zakładkę",
    "New title": "Nowy tytuł",
    "Set as my default view": "Ustaw jako mój widok domyślny",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Default signature": "Default signature",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Czynności",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Czy chcesz zaktualizować powiązane umowy i faktury?",
    "Update contract templates, active contracts and open invoices.": "Aktualizuj szablony umów, aktywne umowy i otwarte faktury.",
    "The following fields will be updated": "Następujące pola zostaną zaktualizowane",
    "Custom Value": "Wartość Niestandardowa",
    "This product is in use. Do you wish to archive it?": "Ten produkt jest w użyciu. Czy chcesz go zarchiwizować?",
    "Are you sure that you want to delete this product?": "Czy na pewno chcesz usunąć ten produkt?",
    "Customize for client": "Dostosuj dla klienta",
    "Customize for template": "Dostosuj do szablonu",
    "Open product template": "Otwórz szablon produktu",
    "Create product template": "Utwórz szablon produktu",
    "Master template": "Szablon główny",
    "Client product": "Produkt klienta",
    "Client product / service": "Produkt / usługa klienta",
    "New client product": "Nowy produkt klienta",
    "Template product": "Produkt szablonowy",
    "Template product / service": "Szablon produktu / usługi",
    "New template product": "Nowy produkt szablonowy",
    "Edit translations": "Edytuj tłumaczenia",
    "Billable topics": "Tematy płatne",
    "Billable time": "Czas rozliczeniowy",
    "Minimum quantity": "Minimalna ilość",
    "Minimum time": "Minimalny czas",
    "Integration parameters": "Parametry integracji",
    "Empty values will use product default": "Puste wartości spowodują użycie domyślnego produktu",
    "Pricing": "Cennik",
    "DC %": "Rabat %",
    "Sum all matching rows": "Zsumuj wszystkie pasujące wiersze",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Gdy opcja ta jest włączona, łączna cena jest skumulowaną sumą wszystkich pasujących wierszy. Domyślnie cena całkowita wykorzystuje tylko najwyższy pasujący wiersz.",
    "Prices since": "Ceny od",
    "Add price": "Dodaj cenę",
    "Add pricing period": "Dodaj okres cenowy",
    "Update contracts": "Aktualizuj umowy",
    "(Without topic)": "(Bez tematu)",
    "Fixed price": "Stała cena",
    "Product": "Produkt",
    "Event created": "Wydarzenie utworzone",
    "Project created": "Projekt utworzony",
    "Event deleted": "Wydarzenie usunięte",
    "Project deleted": "Projekt usunięty",
    "Workflow added": "Cykl pracy dodany",
    "Workflow removed": "Cykl pracy usunięty",
    "Workflow updated": "Cykl pracy zaktualizowany",
    "Event cancelled": "Wydarzenie odwołane",
    "Project cancelled": "Projekt anulowany",
    "Event reactivated": "Zdarzenie reaktywowane",
    "Project reactivated": "Projekt został reaktywowany",
    "Event archived": "Wydarzenie zarchiwizowane",
    "Project archived": "Projekt zarchiwizowany",
    "Event unarchived": "Zdarzenie niearchiwizowane",
    "Project unarchived": "Projekt niezarchiwizowany",
    "Event changed": "Wydarzenie zmienione",
    "Project changed": "Projekt został zmieniony",
    "Event status changed: {0}": "Zmieniono status zdarzenia: {0}",
    "Project status changed: {0}": "Zmieniono status projektu: {0}",
    "Event status changed": "Status zdarzenia został zmieniony",
    "Project status changed": "Status projektu został zmieniony",
    "Task created": "Zadanie utworzone",
    "Task changed": "Zadanie zmienione",
    "Task finished": "Zadanie zakończone",
    "Task not finished": "Zadanie nie jest zakończone",
    "Task deleted": "Zadanie usunięte",
    "Add project": "Dodaj projekt",
    "Hide filters": "Ukryj filtry",
    "Show filters": "Pokaż filtry",
    "Cancel event": "Anuluj wydarzenie",
    "Cancel project": "Anuluj projekt",
    "Manage event fields": "Zarządzaj polami zdarzeń",
    "Manage project fields": "Zarządzaj polami projektu",
    "New event": "Nowe wydarzenie",
    "New project": "Nowy projekt",
    "{0} (Copy)": "{0} (Kopiuj)",
    "Are you sure you wish to delete this project?": "Czy na pewno chcesz usunąć ten projekt?",
    "Are you sure to archive this event?": "Czy na pewno chcesz zarchiwizować to wydarzenie?",
    "Are you sure to archive this project?": "Czy na pewno chcesz zarchiwizować ten projekt?",
    "Are you sure to cancel this event?": "Czy na pewno chcesz odwołać to wydarzenie?",
    "Are you sure to cancel this project?": "Czy na pewno chcesz anulować ten projekt?",
    "Communication": "Komunikacja",
    "Log": "Dziennik",
    "Create event workflow": "Utwórz przepływ pracy zdarzeń",
    "Create project workflow": "Utwórz przepływ pracy projektu",
    "Use workflow templates to set up tasks effectively or": "Korzystaj z szablonów przepływu pracy, aby efektywnie konfigurować zadania lub",
    "Add tasks manually": "Dodaj zadania ręcznie",
    "Save bookmark": "Zapisz zakładkę",
    "Remove filters": "Usuń filtry",
    "Filter": "Filtr",
    "Show multiselect": "Pokaż wielokrotny wybór",
    "To do today": "Do zrobienia dzisiaj",
    "This and next month": "Ten i przyszły miesiąc",
    "Last 3 months": "Ostatnie 3 miesiące",
    "Next 3 months": "Następne 3 miesiące",
    "Starts": "Rozpoczyna się",
    "To do": "Do zrobienia",
    "today": "dzisiaj",
    "tomorrow": "jutro",
    "yesterday": "wczoraj",
    "Previous week": "Poprzedni tydzień",
    "Group similar tasks": "Grupuj podobne zadania",
    "Group by client": "Grupuj według klienta",
    "Group by date": "Grupuj według daty",
    "Group by topic": "Grupuj według tematu",
    "Your details": "Twoje szczegóły",
    "City": "Miasto",
    "Regional format": "Format regionalny",
    "Default company": "Domyślna firma",
    "Lock time entries notification": "Powiadomienie o zablokowaniu wpisów czasu",
    "Notify by": "Powiadom przez",
    "Delete my account": "Usuń moje konto",
    "Attention": "Uwaga",
    "Are you sure that you want to delete your account?": "Czy na pewno chcesz usunąć swoje konto?",
    "Notification": "Powiadomienie",
    "Notification & email": "Powiadomienie i e-mail",
    "Vacations / absence": "Wakacje / nieobecność",
    "Edit balance": "Edytuj saldo",
    "View history": "Zobacz historię",
    "Request": "Wniosek",
    "How long": "Jak długo",
    "Requested": "Wymagany",
    "Approved": "Zatwierdzony",
    "Rejected": "Odrzucony",
    "In review": "W recenzji",
    "Change": "Zmień",
    "Agreements": "Umowy",
    "New agreement": "Nowa umowa",
    "Change agreement": "Zmień umowę",
    "Stop demo": "Zatrzymaj demo",
    "Show": "Pokaż",
    "Don't show": "Nie pokazuj",
    "Don't send": "Nie wysyłaj",
    "Email workdays at 7 AM": "E-mail w dni robocze o 7:00",
    "Email at 3 PM": "E-mail o 15:00",
    "Email at once": "Wyślij e-mail od razu",
    "Email Sundays at 11 PM": "E-mail w niedziele o 23:00",
    "First day of the month": "Pierwszy dzień miesiąca",
    "to email": "wysłać e-mail",
    "E-mail at once": "E-mail od razu",
    "System": "System",
    "Person": "Osoba",
    "Picture": "Zdjęcie",
    "Time zone": "Strefa czasowa",
    "Calendar settings": "Ustawienia kalendarza",
    "Public holidays": "Święta",
    "Tax deadlines": "Terminy podatkowe",
    "News": "Aktualności",
    "External services": "Usługi zewnętrzne",
    "Google log in": "Zaloguj się przez Google",
    "Microsoft log in": "Zaloguj się przez Microsoft",
    "Are you sure to remove microsoft?": "Czy na pewno chcesz usunąć połączenie Microsoft?",
    "Agreement": "Umowa",
    "Active agreement": "Aktywna umowa",
    "Weekly hours": "Godziny tygodniowe",
    "Are you sure to remove google?": "Czy na pewno chcesz usunąć połączenie Google?",
    "Edit supplier": "Edytuj dostawcę",
    "New supplier": "Nowy dostawca",
    "Are you sure you wish to delete this supplier?": "Czy na pewno chcesz usunąć tego dostawcę?",
    "Add supplier": "Dodaj dostawcę",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Typy dostawców nie są zdefiniowane. Prosimy przejść do ustawień aplikacji dostawcy, aby dodać.",
    "No members yet": "Nie ma jeszcze członków",
    "Edit group": "Edytuj grupę",
    "Add group": "Dodaj grupę",
    "Are you sure to delete this user group?": "Czy na pewno chcesz usunąć tę grupę użytkowników?",
    "Get set up to work with team": "Przygotuj się do pracy z zespołem",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Konto firmowe umożliwia korzystanie z narzędzi dla zespołów, uzyskiwanie głębszych analiz itp. Podnieś jakość przepływu pracy zespołu i prowadź bardziej dochodowy biznes.",
    "Create company account": "Utwórz konto firmy",
    "By creating a company account you activate Uku free subscription for {0} days.": "Zakładając konto firmowe aktywujesz darmowy abonament Uku na {0} dni.",
    "You have invited {0}/{1} members": "Zaprosiłeś {0}/{1} członków",
    "Upgrade": "Uaktualnij",
    "Resend invite": "Wyślij ponownie zaproszenie",
    "Send invite": "Wyślij zaproszenie",
    "View profile": "Zobacz profil",
    "To add members to your team, you'll need to create a company account": "Aby dodać członków do swojego zespołu, musisz utworzyć konto firmowe",
    "Export": "Eksportuj",
    "Re-invite sent": "Ponowne zaproszenie wysłane",
    "View report": "Zobacz raport",
    "Member {0} will be deactivated.": "Członek {0} zostanie dezaktywowany.",
    "Please select new member who will replace {0}.": "Proszę wybrać nowego członka, który zastąpi {0}.",
    "Select new member": "Wybierz nowego członka",
    "NB! Deactivation process cannot be reversed": "UWAGA! Procesu dezaktywacji nie można odwrócić",
    "Magic button settings": "Ustawienia magicznego przycisku",
    "Create only one task per month": "Twórz tylko jedno zadanie miesięcznie",
    "Current month's tasks": "Zadania na bieżący miesiąc",
    "extra work": "dodatkowa praca",
    "Without topic": "Bez tematu",
    "Week": "Tydzień",
    "Previous month": "Poprzedni miesiąc",
    "task | tasks": "zadanie | zadania",
    "Assign to": "Przypisz do",
    "Mark as done": "Oznacz jako wykonane",
    "Last": "Ostatni, ubiegły, zeszły",
    "Snooze": "Drzemka",
    "1 dependency": "1 zależność",
    "{0} dependencies": "{0} zaleźności",
    "Client request": "Żądanie klienta",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Dodaj komentarz",
    "Internal comment": "Komentarz wewnętrzny",
    "Portal message": "Wiadomość portalu",
    "Public message means that clients can read it and the client portal will notify them by email": "Wiadomość publiczna oznacza, że klienci mogą ją przeczytać, a portal klienta powiadomi ich o tym e-mailem",
    "Type a comment": "Wpisz komentarz",
    "Send portal message": "Wyślij wiadomość portalu",
    "Open timesheet": "Otwórz arkusz czasu pracy",
    "Pause timer": "Zapauzuj timer",
    "Mark undone": "Zaznacz cofnięte",
    "Digitise": "Digitalizuj",
    "Documents sent to digitisation": "Dokumenty przesłane do digitalizacji",
    "Followers": "Obserwujący",
    "Start / Due date": "Data rozpoczęcia / płatności",
    "Select topic": "Wybierz temat",
    "1 document": "1 dokument",
    "{0} documents": "{0} dokumenty",
    "Download": "Pobierz",
    "Download all": "Pobierz wszystko",
    "Assign as task": "Przypisz jako zadanie",
    "When selected, the task is sent as a task to the client": "Po wybraniu zadanie jest wysyłane jako zadanie do klienta",
    "Auto finish": "Automatyczne zakończenie",
    "When selected, the task is marked done after client finishes it": "Po wybraniu zadanie jest oznaczane jako wykonane po jego zakończeniu przez klienta",
    "Add comment / message": "Dodaj komentarz / wiadomość",
    "Add email": "Dodaj e-maila",
    "Add estimation": "Dodaj oszacowanie",
    "Add task field": "Dodaj pole zadania",
    "Add dependency": "Dodaj zależność",
    "Drop files to upload": "Upuść pliki do przesłania",
    "Task sent to client portal": "Zadanie wysłane do portalu klienta",
    "Task no longer assigned to client portal": "Zadanie nie jest już przypisane do portalu klienta",
    "Save recurring task": "Zapisz zadanie cykliczne",
    "Add to-do list": "Dodaj listę do zrobienia",
    "Waiting for event status: {0}": "Oczekiwanie na status zdarzenia: {0}",
    "Waiting for project status: {0}": "Oczekiwanie na status projektu: {0}",
    "Edit template task": "Edytuj zadanie szablonu",
    "Create recurring task": "Utwórz zadanie cykliczne",
    "Make a copy": "Zrób kopię",
    "Add topic": "Dodaj temat",
    "Delete task": "Usuń zadanie",
    "Delete task template": "Usuń szablon zadania",
    "Select task field": "Wybierz pole zadania",
    "No custom fields available for this client": "Brak dostępnych pól niestandardowych dla tego klienta",
    "task": "zadanie",
    "recurring task": "zadanie cykliczne",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Czy zamierzasz usunąć siebie z {0}, czy chcesz całkowicie je usunąć?",
    "This {1} is shared with {0}": "Ten {1} jest udostępniony {0}",
    "Remove only me": "Usuń tylko mnie",
    "Time has been tracked to this task.": "Czas został przypisany do tego zadania.",
    "Are you sure to delete this task?": "Czy na pewno chcesz usunąć to zadanie?",
    "Undefined": "Nieokreślony",
    "COPY": "KOPIUJ",
    "On task due date": "W terminie zadania",
    "{0} day before": "{0} dzień do",
    "{0} days before": "{0} dni do",
    "Edit workflow": "Edytuj cykl pracy",
    "Duplicate project": "Zduplikuj projekt",
    "Reset layout": "Zresetuj układ",
    "Any time": "W dowolnym momencie",
    "Assign user...": "Przypisz użytkownika...",
    "1 min": "1 minuta",
    "5 min": "5 minut",
    "10 min": "10 minut",
    "30 min": "30 minut",
    "1 h": "1 godz",
    "Add notes": "Dodaj notatki",
    "Task start date": "Data rozpoczęcia zadania",
    "Task due date": "Termin wykonania zadania",
    "Recurrence task": "Zadanie dotyczące powtarzalności",
    "Search from one time templates": "Wyszukaj z szablonów jednorazowych",
    "Placeholders": "Parametry",
    "New task": "Nowe zadanie",
    "New recurring task": "Nowe zadanie cykliczne",
    "+1 day": "+1 dzień",
    "Edit comment": "Edytuj komentarz",
    "Timer is running!": "Timer działa!",
    "Continue time from {0}": "Kontynuuj czas od {0}",
    "New time entry": "Nowy zapis czasu",
    "Load more": "Załaduj więcej",
    "Are you sure to delete this time entry?": "Czy na pewno chcesz usunąć ten wpis?",
    "Save automated email": "Zapisz automatycznego e-maila",
    "Automation": "Automatyzacja",
    "Are you sure to delete this email?": "Czy na pewno chcesz usunąć tego e-maila?",
    "Are you sure you wish to send this email immediately?": "Czy na pewno chcesz wysłać tę wiadomość natychmiast?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "skomentował",
    "Reply": "Odpowiedź",
    "Are you sure to delete this comment?": "Czy na pewno chcesz usunąć ten komentarz?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "wysłał wiadomość",
    "replied to task email": "replied to task email",
    "failed to send": "nieudane wysłanie",
    "sent email": "wysłano e-mail",
    "no one": "nikt",
    "created this task.": "stworzył to zadanie.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "prośba o pomoc.",
    "updated this task.": "zaktualizował to zadanie.",
    "tracked time to this task.": "śledzony czas do tego zadania.",
    "finished this task.": "zakończył to zadanie.",
    "new comment.": "nowy komentarz.",
    "reassigned this task.": "ponownie przydzielił to zadanie.",
    "assigned the task to {0}.": "przypisał zadanie do {0}.",
    "reminder.": "przypomnienie.",
    "deleted.": "usunięte.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "ukończył zadanie, ale Uku nie ukończył tego zadania automatycznie, ponieważ nie wszystkie wymagania zadania zostały spełnione.",
    "sent task to client portal": "wysłał zadanie do portalu klienta",
    "assigned the task to client.": "przydzielił zadanie klientowi.",
    "assigned the task to company.": "przydzielił zadanie firmie.",
    "added attachment(s).": "dodane załączniki.",
    "added a comment.": "dodał komentarz.",
    "added a message to {0}.": "dodał wiadomość do {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "zaktualizowane notatki.",
    "made changes to checklist.": "wprowadził zmiany na liście kontrolnej.",
    "created this task template.": "stworzył ten szablon zadania.",
    "updated this task template.": "zaktualizował ten szablon zadania.",
    "recurring task assigned.": "przydzielone powtarzające się zadanie.",
    "recurring task deleted.": "zadanie cykliczne usunięte.",
    "added email.": "dodany e-mail.",
    "changed email.": "zmieniony e-mail.",
    "deleted email.": "usunięty e-mail.",
    "sent email.": "wysłany email.",
    "failed to send.": "nie udało się wysłać.",
    "added email": "dodano e-mail",
    "changed email": "zmieniono e-mail",
    "deleted email": "usunięto e-mail",
    "Member / Time": "Członek / Czas",
    "Client/topic": "Klient/temat",
    "Client/task": "Klient/zadanie",
    "Client/member": "Klient/członek",
    "Member/topic": "Członek/temat",
    "Member/task": "Członek/zadanie",
    "Member/client": "Członek/klient",
    "Member/date": "Członek/data",
    "Date/member": "Data/członek",
    "Grouped": "Zgrupowane",
    "Client/project": "Klient/projekt",
    "Project/member": "Projekt/członek",
    "Period balance": "Saldo okresu",
    "Reset balance": "Zresetuj saldo",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Wpis czasu został potwierdzony lub czas trwania został zmieniony, a czas trwania nie będzie dynamicznie aktualizowany",
    "(Without project)": "(Bez projektu)",
    "Decline": "Odrzuć",
    "Accept": "Zaakceptować",
    "Cancel decision": "Anuluj decyzję",
    "Accepted": "Przyjęty",
    "Declined": "Odrzucony",
    "Report data has changed. Please update report.": "Dane raportu uległy zmianie. Zaktualizuj raport.",
    "Agreed": "Zgoda",
    "Non billable": "Nie do rozliczenia",
    "Export report to Excel": "Eksportuj raport do Excela",
    "By default, we export the result of the selected filters with the columns of the configured table": "Domyślnie eksportujemy wynik działania wybranych filtrów wraz z kolumnami skonfigurowanej tabeli",
    "Add to export client custom fields": "Dodaj do eksportu pola własne klienta",
    "Save report": "Zapisz raport",
    "Export PDF": "Eksportuj PDF",
    "Export Excel": "Eksportuj Excel",
    "We have new version of": "Mamy nową wersję",
    "Log out": "Wyloguj",
    "Previous day": "Poprzedni dzień",
    "Next day": "Następny dzień",
    "Mark all as read": "Oznacz wszystkie jako przeczytane",
    "Search task/client": "Wyszukaj zadanie/klienta",
    "from client portal": "z portalu klienta",
    "Hide all": "Ukryj wszystkie",
    "Hide for 1 hour": "Ukryj się na 1 godzinę",
    "Something went wrong": "Coś poszło nie tak",
    "User authentication needed": "Wymagane uwierzytelnienie użytkownika",
    "Invalid rights": "Nieprawidłowe prawa",
    "The object cannot be found": "Nie można znaleźć obiektu",
    "Content too large": "Treść jest zbyt duża",
    "An unknown error occurred": "Wystąpił nieznany błąd",
    "The action requested cannot be performed": "Żądane działanie nie może zostać wykonane",
    "Go": "Idź",
    "Actual / monitoring (month)": "Rzeczywiste/monitorowane (miesiąc)",
    "h": "h",
    "Actual": "Rzeczywisty",
    "Month": "Miesiąc",
    "I’m setting up your account": "Konfiguruję Twoje konto",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Czy wiesz, że biura rachunkowe, które zaczęły korzystać z Uku, mogą w tym samym czasie obsłużyć 38% więcej klientów.",
    "Let’s setup your company": "Skonfigurujmy Twoją firmę",
    "Name of your company": "Nazwa Twojej firmy",
    "Size of your team?": "Wielkość Twojego zespołu?",
    "Which software are you using?": "Jakiego oprogramowania używasz?",
    "This knowledge will help us to improve Uku": "Ta wiedza pomoże nam ulepszyć Uku",
    "What other software needs to be integrated?": "Jakie inne oprogramowanie wymaga integracji?",
    "Book a demo": "Zamów demo",
    "Hi {0},": "Cześć {0},",
    "NO BOTS - ONLY HUMANS": "ŻADNYCH BOTÓW - TYLKO LUDZIE",
    "Start a 14 day free trial": "Rozpocznij 14-dniowy okres próbny",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "“Uku to niesamowicie funkcjonalne oprogramowanie. Uku usprawniło nasze zarządzanie pracą i pomaga nam zapewnić wyjątkową obsługę.”",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Najszybszym sposobem, aby zdecydować, czy Uku może przynieść korzyści {0}, jest krótka {1} minutowa rozmowa z naszym specjalistą ds. wdrażania klientów.",
    "Hi, I'm Uku ": "Cześć, jestem Uku ",
    "I help to set up your account.": "Pomagam założyć konto.",
    "It only takes a minute.": "To zajmuje tylko minutę.",
    "Choose": "Wybierz",
    "Your country": "Twój kraj",
    "Your language": "Wybierz język",
    "Begin": "Rozpocznij",
    "Let’s become friends": "Zostańmy przyjaciółmi",
    "Your first name": "Twoje imię",
    "What is your field of work?": "Jaka jest Twoja dziedzina pracy?",
    "Your field of work": "Twoja dziedzina pracy",
    "How will you use Uku?": "Jak skorzystasz z Uku?",
    "How did you hear about Uku?": "Skąd dowiedziałeś się o Uku?",
    "Choose channel": "Wybierz kanał",
    "Please specify how you heard about us": "Prosimy o określenie, w jaki sposób dowiedziałeś się o nas",
    "Let me know Uku's new features by email": "Powiadom mnie przez e-mail o nowych funkcjach Uku",
    "Finish": "Skończ",
    "First name is required": "Imię jest wymagane",
    "Name is required": "Nazwisko jest wymagane",
    "Team size is required": "Wielkość zespołu jest wymagana",
    "Surname is required": "Nazwisko jest wymagane",
    "Field is required": "Pole jest wymagane",
    "I will use Uku to work together with two or more teammates.": "Użyję Uku do współpracy z dwoma lub więcej kolegami z drużyny.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Sam będę używał Uku. Ten plan jest bezpłatny, ale funkcje są ograniczone.",
    "Media": "Media",
    "Through integration partner": "Przez partnera integracyjnego",
    "Referral by friend": "Polecenie przez przyjaciela",
    "Import speeds up your clients setup, smart choice!": "Import przyspiesza konfigurację klientów, mądry wybór!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Ostatni import: dodano {0}, zaktualizowano {1}, pominięto {2}, nie udało się zaimportować {3} klienta",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Ostatni import: dodano {0}, zaktualizowano {1}, pominięto {2}, nie udało się zaimportować {3} klientów",
    "Last import: added {0}, updated {1}, skipped {2}": "Ostatni import: dodano {0}, zaktualizowano {1}, pomianięto {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Co dalej? Popraw dane {0} klientów i wgraj ponownie.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Zamiast wprowadzać klientów pojedynczo, możesz użyć importu plików dla dużej bazy klientów.",
    "Import all Merit Aktiva clients and keep client data automatically updated": "Import wszystkich klientów Merit Aktiva i automatyczna aktualizacja danych klientów",
    "Ignore": "Zignoruj",
    "NEW CLIENT": "NOWY KLIENT",
    "Preview": "Podgląd",
    "Import started": "Rozpoczęto importowanie",
    "Only new clients": "Tylko nowi klienci",
    "Update data from company register": "Aktualizacja danych z rejestru firm",
    "If switched on, the company data is updated using the local business register": "Jeśli jest włączone, dane firmy są aktualizowane za pomocą lokalnego rejestru przedsiębiorstw",
    "We did not find a match in Äriregister": "Nie znaleźliśmy dopasowania w Ęriregister",
    "We did not find a match in Companies House": "Nie znaleźliśmy dopasowania w Companies House",
    "No integration yet": "Nie ma jeszcze integracji",
    "Uku match": "Uku odpowiednik",
    "Business register nr.": "Rejestr handlowy nr.",
    "Company register": "Rejestr firmowy",
    "Upload file": "Prześlij plik",
    "Before uploading your file": "Przed załadowaniem pliku",
    "Learn Uku’s data structure": "Poznaj strukturę danych Uku",
    "Download and use our sample file to see exactly how we organize data in Uku": "Pobierz i użyj naszego przykładowego pliku, aby zobaczyć dokładnie jak organizujemy dane w Uku",
    "Download Client Import Example": "Pobierz przykład importu klienta",
    "Download Contact Import Example": "Pobierz przykład importu kontaktów",
    "Fill in fields": "Wypełnij pola",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Jedynym obowiązkowym polem jest nazwa firmy. Przed wysłaniem pliku upewnij się, że wypełniłeś wszystkie niezbędne pola.",
    "Learn more about mandatory fields": "Dowiedz się więcej o obowiązkowych polach",
    "Create custom fields": "Stwórz pola niestandardowe",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Niektóre pola danych mogą nie być obecne domyślnie. Najpierw utwórz te pola niestandardowe przed importem danych.",
    "Add new custom fields": "Dodaj nowe pole niestandardowe",
    "...or drag a file here": "…lub przeciągnij tutaj",
    "Only Excel (.xls, .xlsx) file types are supported": "Tylko pliki dla Excela (.xls, .xlsx) są akceptowane",
    "Mapping": "Mapowanie",
    "First row is a header": "Pierwszy wiersz to nagłówek",
    "Add field to all clients": "Dodaj pole do wszystkich klientów",
    "Add client group": "Dodaj grupę klientów",
    "Fields for all clients": "Pola dla wszystkich klientów",
    "Import of {0} in progress": "Import {0} w toku",
    "Import in progress": "Import w toku",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Może to zająć trochę czasu. W tym samym czasie możesz wykonywać inne czynności w Uku, damy Ci znać, gdy będzie gotowe.",
    "Cancel import": "Anuluj import",
    "Are you sure you want to cancel import?": "Czy na pewno chcesz anulować import?",
    "Last updated": "Ostatnio zaktualizowany",
    "Contracts": "Umowy",
    "Job name": "Nazwa zlecenia",
    "Workflow name": "Nazwa cyklu pracy",
    "Details": "Szczegóły",
    "Select jobs": "Wybierz zlecenie",
    "Select task plan": "Wybierz plan zadań",
    "of existing client": "istniejącego klienta",
    "You can also choose": "Możesz również wybrać",
    "existing client tasks plan": "istniejący plan zadań klienta",
    "existing predefined jobs": "istniejące predefiniowane zlecenia",
    "create a new plan": "utwórz nowy plan",
    "Select workflow": "Wybierz cykl pracy",
    "existing project workflow": "istniejący cykl pracy projektu",
    "existing workflow": "istniejący cykl pracy",
    "create a new workflow": "utwórz nowy cykl pracy",
    "New tasks template": "Nowy szablon zadań",
    "to save template!": "aby zapisać szablon!",
    "You can also add tasks from jobs": "Możesz także dodawać zadania ze zleceń",
    "or choose": "lub wybierz",
    "New workflow template": "Nowy szablon cyklu pracy",
    "You can also add tasks from existing workflow templates": "Można również dodać zadania z istniejących szablonów cyklu pracy",
    "existing event workflow": "istniejący przepływ pracy zdarzeń",
    "Hide others": "Ukryj inne",
    "Update all events (New tasks)": "Zaktualizuj wszystkie zdarzenia (nowe zadania)",
    "Update all projects (New tasks)": "Zaktualizuj wszystkie projekty (nowe zadania)",
    "Once": "Raz",
    "Once a month": "Raz w miesiącu",
    "Once a quarter": "Raz na kwartał",
    "Once a year": "Raz w roku",
    "Company workflow": "Organizacja pracy w firmie",
    "Company jobs": "Zlecenia w firmie",
    "Default jobs": "Zlecenia domyślne",
    "ID": "ID",
    "Task title and labels": "Tytuł i etykiety zadania",
    "Assigned and time": "Przypisany i czas",
    "Setup tasks for {0} event": "Skonfiguruj zadania dla zdarzenia {0}",
    "Setup tasks for {0} project": "Skonfiguruj zadania dla projektu {0}",
    "New job": "Nowe zlecenie",
    "Edit job": "Edytuj zlecenie",
    "New workflow": "Nowy cykl pracy",
    "Save workflow": "Zapisz cykl pracy",
    "Create task plan": "Utwórz plan zadań",
    "Confirm task plan": "Potwierdź plan zadań",
    "Skip": "Pomiń",
    "Confirm workflow": "Potwierdź cykl pracy",
    "Client portal templates": "Szablony portalu klienta",
    "Jobs": "Zlecenia",
    "Workflows": "Cykle pracy",
    "Company workflows": "Przepływy pracy w firmie",
    "Default workflows": "Domyślne przepływy pracy",
    "Company template saved": "Zapisany szablon firmy",
    "Company template created": "Utworzony szablon firmy",
    "Format": "Format",
    "Currency": "Waluta",
    "Reference number": "Numer referencyjny",
    "Invoice description": "Opis faktury",
    "Summarize invoice rows": "Podsumuj wiersze faktur",
    "Summarized description": "Skrócony opis",
    "Reverse charge": "Opłata zwrotna",
    "Rounding": "Zaokrąglanie",
    "Time rounding will apply for each line": "Dla każdej linii zostanie zastosowane zaokrąglenie czasu",
    "Rounding increment (up)": "Przyrost zaokrąglania (w górę)",
    "Reply to": "Odpowiedz",
    "Configuration": "Konfiguracja",
    "Invoice to parent company": "Faktura dla spółki dominującej",
    "Create all invoices under parent company.": "Utwórz wszystkie faktury w ramach spółki macierzystej.",
    "User code": "Kod użytkownika",
    "Default": "Domyślny",
    "Default value will apply for each line": "Wartość domyślna zostanie zastosowana dla każdej linii",
    "Number": "Numer",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Do pola prefiksu faktury można wpisać dowolny z poniższych elementów w nawiasach klamrowych. Podczas zapisywania umowy prefiks zostanie wypełniony odpowiednią wartością.",
    "Copy to clipboard": "Skopiuj do schowka",
    "Invoice previous period": "Faktura za poprzedni okres",
    "Invoice period": "Okres faktury",
    "Invoice next period": "Faktura za następny okres",
    "Client primary user": "Główny uytkownik klienta",
    "Original client name": "Oryginalna nazwa klienta",
    "invoice date year": "data (rok) faktury",
    "last two digits of invoice date year": "ostatnie dwie cyfry roku daty faktury",
    "invoice date month": "data (miesiąc) faktury",
    "invoice date day": "data (dzień) faktury",
    "Copied to clipboard": "Skopiowano do schowka",
    "Contract": "Umowa",
    "Net total": "Net total",
    "Contract #": "Kontrakt #",
    "Invoice #": "Faktura #",
    "Exported": "Wyeksportowany",
    "Sent": "Wysłany",
    "Net": "Netto",
    "Add invoice": "Dodaj fakturę",
    "Change invoice number": "Zmień numer faktury",
    "Review changes": "Przejrzyj zmiany",
    "Please review and approve changes to the related events": "Przejrzyj i zatwierdź zmiany w powiązanych wydarzeniach",
    "Please review and approve changes to the related projects": "Przejrzyj i zatwierdź zmiany w powiązanych projektach",
    "Contains": "Zawiera",
    "contains": "zawiera",
    "Exactly": "Dokładnie",
    "is exactly": "jest dokładnie",
    "Greater than": "Większe niż",
    "is greater than": "jest większe niż",
    "Less than": "Mniej niż",
    "is less than": "jest mniej niż",
    "Range": "Zakres",
    "is in range of": "jest w zakresie",
    "is empty": "jest pusty",
    "Task plan": "Plan zadań",
    "Edit plan": "Edytuj plan",
    "Use task plan templates to set up tasks effectively or add a task manually": "Korzystaj z szablonów planu zadań, aby efektywnie konfigurować zadania lub dodawaj zadania ręcznie",
    "Add task manually": "Dodaj zadanie ręcznie",
    "Quarterly": "Kwartalny",
    "Export excel": "Eksportuj Excela",
    "Print PDF": "Drukuj PDF",
    "Edit jobs": "Edytuj zlecenia",
    "Replace plan tasks with job": "Zastąp plany zadań zleceniami",
    "Select template": "Wybierz szablon",
    "member": "członek",
    "Tasks with user will be added to every selected client": "Zadania z użytkownikiem zostaną dodane do każdego wybranego klienta",
    "Add even if job already applied": "Dodaj, nawet jeśli praca została już zgłoszona",
    "Default user": "Domyślny użytkownik",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Spowoduje to usunięcie wszystkich zadań z planu klienta i umieszczenie w nim tylko wybranych zadań szablonu",
    "Adding template will be ready in a minute. You can continue with work.": "Dodanie szablonu będzie gotowe za minutę. Możesz kontynuować pracę.",
    "Add client": "Dodaj klienta",
    "Export clients": "Eksportuj klientów",
    "Export client contacts": "Eksportuj kontakty klientów",
    "client | clients": "klient | klienci",
    "clients": "klienci",
    "client(s) had errors": "klient/klienci miał/mieli błędy",
    "client(s) selected": "wybrani klienci",
    "Contract actions": "Działania kontraktowe",
    "Edit Members": "Edytuj członków",
    "Edit monitoring": "Edytuj monitorowanie",
    "Your company": "Twoja firma",
    "Edit billing": "Edytuj rozliczenie",
    "Activate client portal": "Aktywuj portal klienta",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Po aktywacji możesz wysyłać zadania bezpośrednio do wszystkich kontaktów klienta, które mają adres e-mail.",
    "Send welcome invitation to client contacts": "Wyślij zaproszenie powitalne do kontaktów klienta",
    "Who will receive an invitation?": "Kto otrzyma zaproszenie?",
    "Client contact who has one valid e-mail address": "Kontakt z klientem, który ma jeden ważny adres e-mail",
    "Client contact who has the client's portal open (default for all)": "Kontakt klienta, który ma otwarty portal klienta (domyślnie dla wszystkich)",
    "How does the invitation work?": "Jak działa zaproszenie?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku tworzy i wysyła \"Zadanie powitalne\" do każdego kontaktu z klientem. Jest ono tworzone przez głównego użytkownika klienta na podstawie szablonu zadania \"Witamy w portalu klienta\". Sprawdź go w szablonach zadań swojej firmy. Zostanie ono przetłumaczone zgodnie z językiem kontaktu.",
    "Uku client portal always informs clients by email about new tasks.": "Portal klienta Uku zawsze informuje klientów e-mailem o nowych zadaniach.",
    "View templates": "Zobacz szablony",
    "Client portal activated": "Portal klienta został aktywowany",
    "Company's name": "Nazwa firmy",
    "Mark": "Ocena",
    "Add members": "Dodaj członków",
    "Members and groups": "Członkowie i grupy",
    "Topic is required": "Temat jest wymagany",
    "Entering time is required": "Wpisanie czasu jest wymagane",
    "Delete client": "Usuń klienta",
    "Manage client fields": "Zarządzaj polami klientów",
    "Max 3 characters": "Maks. 3 znaki",
    "Are you sure you wish to delete this client?": "Czy na pewno chcesz usunąć tego klienta?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Usunięcie danych klienta spowoduje również usunięcie wszystkich zadań związanych z klientem.<br/><br/>Uwaga! Historia klienta zostanie usunięta",
    "Owner": "Właściciel",
    "All clients that you add under {0} will be deleted later.</div>": "Wszyscy klienci, których dodasz do {0}. <span class='error—text font-weight-medium'>zostaną później usunięci</span>.</div>",
    "Use this account for testing purposes only!": "Użyj tego konta tylko do celów testowych!",
    "Read more about the demo account": "Dowiedz się więcej o koncie demo",
    "Rights": "Prawa",
    "Monitoring setup": "Konfiguracja monitorowania",
    "Learn more about monitoring": "Dowiedz się więcej o monitorowaniu",
    "selected": "wybrany",
    "Invoicing": "Fakturowanie",
    "Billing template": "Szablon rozliczeniowy",
    "New": "Nowe",
    "Add row": "Dodaj wiersz",
    "Delete contract": "Usuń umowę",
    "Product / description": "Opis produktu",
    "Qty": "Ilość",
    "Product placeholders": "Parametry produktu",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Zapisano szablon",
    "Warning": "Ostrzeżenie",
    "Would you like to apply these changes to all clients using this contract template?": "Czy chcesz zastosować te zmiany do wszystkich klientów korzystających z tego szablonu umowy?",
    "Yes, apply to all clients": "Tak, aplikuj do wszystkich klientów",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Wprowadziłeś zmiany w okresie, którego dotyczy niniejsza umowa rozliczeniowa. Może to zmienić sposób, w jaki nierozliczone usługi w przeszłości i w przyszłości będą fakturowane. Potwierdź, że ta zmiana była zamierzona.",
    "Are you sure to delete this template?": "Czy na pewno chcesz usunąć ten szablon?",
    "Save template": "Zapisz szablon",
    "Save as template": "Zapisz jako szablon",
    "Please note all changes made to contract will be lost": "Pamiętaj, że wszystkie zmiany w umowie zostaną utracone",
    "Add contract": "Dodaj umowę",
    "Manage contract templates": "Zarządzaj szablonami umów",
    "Change account details": "Zmień dane konta",
    "Country is required": "Kraj jest wymagany",
    "Address": "Adres",
    "Postal code": "Kod pocztowy",
    "State": "Stan",
    "Uku is set up according to the field of work.": "Uku jest skonfigurowane zgodnie z dziedziną pracy.",
    "Size of the team": "Wielkość zespołu",
    "Website": "Website",
    "Delete account": "Usuń konto",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Usunięcie konta spowoduje również usunięcie wszystkich klientów powiązanych z kontem, ich zadań i całej historii. Czy na pewno chcesz usunąć swoje konto?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Tak, usuń konto ze wszystkimi powiązanymi danymi, takimi jak klienci, zadania i cała historia",
    "These invoices cannot be sent. Check their status or error messages.": "Te faktury nie mogą zostać wysłane. Sprawdź ich status lub komunikaty o błędach.",
    "Please confirm that you wish to proceed.": "Potwierdź, że chcesz kontynuować.",
    "Sending invoice | Sending invoices": "Wysyłanie faktury | Wysyłanie faktur",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Za chwilę wyślesz tę fakturę e-mailem do klienta. | Za chwilę wyślesz te faktury do klientów e-mailem.",
    "Error in calculating invoice": "Błąd w obliczeniu faktury",
    "Error in importing invoice": "Błąd podczas importowania faktury",
    "Error in creating invoice": "Błąd podczas tworzenia faktury",
    "Error in exporting invoice": "Błąd w eksporcie faktury",
    "Error in sending invoice": "Błąd w wysyłaniu faktury",
    "Calculating invoice": "Obliczanie faktury",
    "Creating invoice": "Tworzenie faktury",
    "Exporting invoice": "Eksport faktury",
    "Importing invoice": "Import faktury",
    "Sending invoice": "Wysyłanie faktury",
    "Clear errors": "Usuń błędy",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Powiązane prace będą ponownie rozliczane. Faktury nie zostaną usunięte z systemów zewnętrznych, będziesz musiał to zrobić ręcznie.",
    "Delete invoice | Deleting invoices": "Usuń fakturę | Usuwanie faktur",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Nic na fakturach",
    "Please make sure you have setup recurring billing for your clients": "Upewnij się, że masz skonfigurowane rozliczenia cykliczne dla swoich klientów",
    "Draft": "Szkic",
    "Approval": "Zatwierdzenie",
    "Created": "Utworzono",
    "Coming soon": "Wkrótce",
    "Selected invoices and related product info will be sent to accounting system.": "Wybrane faktury i powiązane informacje o produktach zostaną przesłane do systemu księgowego.",
    "Piece": "Szt.",
    "Hour": "Godzina",
    "Delete row": "Usuń wiersz",
    "Out of ": "Z ",
    " can be created": " można stworzyć",
    "For ": "Do ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " okres fakturowania nadal trwa. Wszelkie prace wykonane w tym okresie po utworzeniu faktury nie będą fakturowane.",
    "Invoice date will be set to today.": "Data faktury zostanie ustawiona na dziś.",
    "Uku is about to create": "Uku ma zamiar stworzyć",
    " selected row, only | selected row, only ": " wybrany wiersz, tylko | wybrany wiersz, tylko ",
    " invoice | invoices": " faktura | faktury",
    "These invoices cannot be exported. Check their status or error messages.": "Tych faktur nie można wyeksportować. Sprawdź ich status lub komunikaty o błędach.",
    "Exporting invoice | Exporting invoices": "Eksport faktury | Eksportowanie faktur",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Masz zamiar wyeksportować tę fakturę do księgowości. | Masz zamiar wyeksportować te faktury do księgowości.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "Pobierz PDF",
    "Create invoice": "Wystaw fakturę",
    "Update status from {0}": "Zaktualizuj status z {0}",
    "Show all lines": "Pokaż wszystkie linie",
    "Calculate invoice": "Oblicz fakturę",
    "Loading invoice...": "Wczytuję fakturę...",
    "Invalid Scoro credentials": "Nieprawidłowe poświadczenia Scoro",
    "Please confirm the changes you have made to this invoice.": "Potwierdź zmiany wprowadzone na tej fakturze.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "Uwaga! Pamiętaj, że zmieniona faktura nie zostanie automatycznie wysłana do klienta ani wyeksportowana do systemów zewnętrznych - trzeba zrobić to ręcznie.",
    "Invoice number already exists! Please confirm to save anyway.": "Numer faktury już istnieje! Proszę potwierdzić, aby mimo wszystko zapisać.",
    "Error in data": "Błąd w danych",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Okres fakturowania nadal trwa. Wszelkie prace wykonane w tym okresie po utworzeniu faktury nie będą fakturowane.",
    "Creation date": "Data utworzenia",
    "{0} days after": "{0} dni po",
    "{0} day after": "{0} dzień po",
    "right away when": "od razu kiedy",
    "start date": "data początkowa",
    "due date": "data końcowa",
    "finished": "ukończono",
    "Entries count": "Liczba wpisów",
    "Entries excluding sales": "Wpisy bez sprzedaży",
    "Entries excluding bank": "Wpisy bez banku",
    "Entries excluding documents": "Wpisy bez dokumentów",
    "Documents (sales and purchases)": "Dokumenty (sprzedaż i zakupy)",
    "Cash entries": "Wpisy gotówkowe",
    "VAT entries": "Wpisy VAT",
    "Stock entries": "Wpisy giełdowe",
    "Sale entries": "Wpisy sprzedaży",
    "Purchase entries": "Wpisy kupna",
    "Bank entries": "Wpisy bankowe",
    "Ledger entries": "Wpisy księgi",
    "Depreciation entries": "Wpisy amortyzacyjne",
    "Entry lines count": "Liczba linii wprowadzania danych",
    "Company owner": "Właściciel firmy",
    "Activity": "Działalność",
    "Oldest first": "Najpierw najstarsze",
    "Newest first": "Najpierw najnowsze",
    "Quantity as time": "Ilość jako czas",
    "Quantity as number": "Ilość jako liczba",
    "Quantity as time in number format": "Ilość jako czas w formacie liczbowym",
    "No rounding": "Brak zaokrągleń",
    "min": "min",
    "hour": "godzina",
    "Last day of month": "Ostatni dzień miesiąca",
    "Invoice line": "Linia faktury",
    "Task time total (per member)": "Łączny czas zadania (na członka)",
    "Time entry": "Wprowadzanie czasu",
    "Task finish date": "Data zakończenia zadania",
    "Create separately": "Utwórz osobno",
    "Merge into one": "Połącz w jedno",
    "No minimum": "Brak minimum",
    "{0} minute": "{0} minuta",
    "{0} minutes": "{0} minut",
    "{0} hour": "{0} godzina",
    "{0} hours": "{0} godzin",
    "English": "Angielski",
    "Estonian": "Estoński",
    "Danish": "Duński",
    "Lithuanian": "Litewski",
    "Russian": "Rosyjski",
    "Finnish": "Fiński",
    "Swedish": "Szwedzki",
    "Norwegian": "Norweski",
    "Latvian": "Łotewski",
    "Bulgarian": "Bułgarski",
    "German": "Niemiecki",
    "Spanish": "Hiszpański",
    "Polish": "Polski",
    "Field: ": "Pole: ",
    "Normal hours": "Normalne godziny",
    "Year": "Rok",
    "Estonia": "Estonia",
    "Finland": "Finlandia",
    "Poland": "Polska",
    "Connection successful!": "Połączenie powiodło się!",
    "User": "Użytkownik",
    "None": "Nic",
    "Error!": "Błąd!",
    "Pending": "Oczekujące",
    "Finished": "Skończone",
    "Text": "Tekst",
    "Choice": "Wybór",
    "Yes/No": "Tak/Nie",
    "Integer": "Liczba całkowita",
    "Multiple choice": "Wielokrotny wybór",
    "URL": "URL",
    "Multiple users": "Wielu użytkowników",
    "Multiline text": "Tekst multilinii",
    "Must be a integer": "Musi być liczbą całkowitą",
    "Must be a date": "Musi być datą",
    "Must be a valid e-mail address": "Musi być poprawnym adresem e-mail",
    "Unknown choice": "Nieznany wybór",
    "Some errors occurred:": "Wystąpiły pewne błędy:",
    "Unknown network error": "Nieznany błąd sieci",
    "Could not connect to the service": "Nie można połączyć się z usługą",
    "Reload this page": "Załaduj tę stronę ponownie",
    "Invoice paid": "Faktura zapłacona",
    "Annulled": "Anulowano",
    "Processing": "Przetwarzanie",
    "You are about to deactivate this app.": "Zamierzasz wyłączyć tę aplikację.",
    "You are about to disconnect this app.": "Za chwilę rozłączysz tę aplikację.",
    "Do you also want to activate billing to get the most out of Uku?": "Czy chcesz także aktywować rozliczenia, aby w pełni wykorzystać możliwości Uku?",
    "Invoice": "Faktura",
    "Clients - Monitoring": "Klienci - Monitorowanie",
    "Links": "Odnośniki",
    "New template": "Nowy szablon",
    "Import Clients from Excel": "Importuj Klientów z Excela",
    "Importer": "Importer",
    "Import clients from Excel": "Zaimportuj klientów z Excela",
    "Account settings": "Ustawienia konta",
    "Empty": "Pusty",
};
export default translations